import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react'
import AdminContext from '../../admin/StateContext/Application'
import ReactApexChart from 'react-apexcharts';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./page.css";
import { Approved32, Click32, Disable32, Earnings, Earningss, Earningsss, Error32, fifth, first, forth, Graph64, MoreMenu64, NewTasks64, Sales, Second, Spendthismonth64, third, TotalProjects64, Unclick32, YourBalance, ECSFile, TotalProjectCost, TotalProjectCost11, TotalLimitAlloted123, TotalWorkOrders, TotalAmountRelease, TotalBillAmount64, TotalDeductionAmount64, Edit32, Delete32 } from '../../../public/LoginImages/importimages';
import '../../Users/pages/innercss.css'
import { useLanguage } from '../../../lang/langcontext/LanguageContext';
import autoTable from "jspdf-autotable";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import "./ProjectDashboard.css"
import GooglePagination from '../styles/GooglePagination';
import { formatDateTime, formatDate } from '../../../utils/DateFormat';

// ── Debounce hook ─────────────────────────────────────────────────────────────
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
}

const Dashboard = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const content = useContext(AdminContext);
  const { GetTaxAmounts, GetVendorBills, getTaxAmountsByDate, GetDateWiseData, GetProjectInfo, GetOverLappingData, GetTotalTableData } = content;

  // ── Core state ────────────────────────────────────────────────────────────
  const [getData, SetData] = useState({});
  const [vendorbills, setVendorBills] = useState([]);
  const [loading, setloading] = useState(false);
  const [dateData, setDateData] = useState([]);
  const [projectdata, setProjectData] = useState([]);
  const [projectId, setProjectId] = useState('');

  const [MHUID, setMHUID] = useState('');
  const [workCostData, setWorkCostData] = useState([]);
  const [limitAllotedData, setLimitAllotedData] = useState([]);
  const [amountReleasedData, setAmountReleasedData] = useState([]);
  const [workOrdersData, setWorkOrdersData] = useState([]);

  const [headFetchedData, setHeadFetchedData] = useState([]);
  const [deductionData, setDeductionData] = useState([]);
  const [newData, setnewData] = useState([]);
  // console.log("newdata..........",newData);

  const [overlappingData, setOverlappingData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedHeadCode, setSelectedHeadCode] = useState("");
  const [workCostSearch, setWorkCostSearch] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [billSummarySearch, setBillSummarySearch] = useState("");
  const [billDetailsSearch, setBillDetailsSearch] = useState("");
  const [deductionSummarySearch, setDeductionSummarySearch] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 300);

  const [selectedYear, setSelectedYear] = useState("All");
  const [proposalCount, setProposalCount] = useState(0);
  const [technicalCount, setTechnicalCount] = useState(0);
  const [workorderCount, setWorkorderCount] = useState(0);
  const [billCount, setBillCount] = useState(0);
  const [chartLoading, setChartLoading] = useState(false);

  const [showspecific, setShowSpecific] = useState(0);
  const [showWorkCostTable, setShowWorkCostTable] = useState(false);
  const [showLimitAllotedTable, setShowLimitAllotedTable] = useState(false);
  const [showAmountReleasedTable, setShowAmountReleasedTable] = useState(false);
  const [showWorkOrdersTable, setShowWorkOrdersTable] = useState(false);
  const [exportingPDF, setExportingPDF] = useState(false);
  const [showGraph, setShowGraph] = useState("Table");

  const [UserRole, setUserRole] = useState("");
  const [typeofData, settypeofData] = useState("Select Head Code");
  const [RoleID, setroleID] = useState(null);

  const { GetProposallist, WorkOutwards, TechnicalOutwards, Usermenu } = content;

  const [baseData, setBaseData] = useState([]);
  const [showList, setShowList] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const isAutoSettingHeadcode = useRef(false);
  const projectIdRef = useRef(projectId);
  projectIdRef.current = projectId;

  // Track if initial load has run
  const initialLoadDone = useRef(false);


  const [selectedWorkOrderType, setSelectedWorkOrderType] = useState("");
  const [existingData, setExistingData] = useState([]);
  const [selectedExistingWorkOrder, setSelectedExistingWorkOrder] = useState("");
  const [proposalUID, setProposalUID] = useState("");

  const [showBillSummary, setShowBillSummary] = useState(false);
  const [billSummaryData, setBillSummaryData] = useState([]);
  const [loadingBillSummary, setLoadingBillSummary] = useState(false);
  const [billDetailsData, setBillDetailsData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [previousPage, setPreviousPage] = useState(5);
const [allowedHeadCodes, setAllowedHeadCodes] = useState([]);
 

  // ── Helpers ───────────────────────────────────────────────────────────────
  const isElementVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  };

  const normalizeText = (text) =>
    text?.toString().normalize("NFC").replace(/\s+/g, " ").trim().toLowerCase();

    const workCostFilteredData = useMemo(() => {
  let data = [...(workCostData || [])];

  // District filter
if ([24, 25, 40, 41, 29].includes(RoleID)) {
  if (selectedDistrict) {
    const selected = normalizeText(selectedDistrict);
 
    data = data.filter((item) => {
      const itemDistrict = normalizeText(item.talulka || item.District);
 
      return (
        itemDistrict === selected ||
        itemDistrict.startsWith(`${selected}-`)
      );
    });
  }
} else {
  // Other roles → normal District filtering
  if (selectedDistrict) {
    const selected = normalizeText(selectedDistrict);
 
    data = data.filter((item) => {
      const itemDistrict = normalizeText(item.talulka || item.District);
 
      return (
        itemDistrict === selected ||
        itemDistrict.startsWith(`${selected}-`)
      );
    });
  }
}

  // Taluka filter
  if (selectedTaluka) {
    data = data.filter(
      item => normalizeText(item.Taluka || item.ulb) === normalizeText(selectedTaluka)
    );
  }

  // HeadCode filter
  if (selectedHeadCode) {
    data = data.filter(
      item => normalizeText(item.HeadCode) === normalizeText(selectedHeadCode)
    );
  }

  // Random search
  if (workCostSearch.trim()) {
    const search = normalizeText(workCostSearch);

    data = data.filter(item => {
      const combined = normalizeText(`
        ${item.Taluka || item.ulb || ""}
        ${item.HeadCode || ""}
        ${item.WorkName || item.Work_name || ""}
        ${item.TechnicalUID || ""}
        ${item.MHUID || ""}
        ${item.TechnicalSanctionNo || ""}
        ${item.ProposalID || ""}
        ${item.ApprovedWorkAmount || ""}
        ${item.Proposal_amount || ""}
      `);

      return combined.includes(search);
    });
  }

  return data;
}, [
  workCostData,
  selectedTaluka,
  selectedHeadCode,
  workCostSearch,
  selectedDistrict
]);

const talukaOptions = useMemo(() => {
  let data = [...(workCostData || [])];
 
  // RoleID 24, 25, 40, 41, 29
  // Taluka should be shown only after District is selected
  if ([24, 25, 40, 41, 29].includes(RoleID)) {
    if (!selectedDistrict) {
      return [];
    }
 
    const selected = normalizeText(selectedDistrict);
 
    data = data.filter((item) => {
      const itemDistrict = normalizeText(item.talulka || item.District);
 
      return (
        itemDistrict === selected ||
        itemDistrict.startsWith(`${selected}-`)
      );
    });
  }
 
  return [...new Set(
    data
      .map(item => item.Taluka || item.ulb)
      .filter(Boolean)
  )].sort();
 
}, [workCostData, selectedDistrict, RoleID]);

//--> old code
// const talukaOptions = useMemo(() => {
//   return [...new Set(
//     (workCostData || [])
//       .map(item => item.Taluka)
//       .filter(Boolean)
//   )].sort();
// }, [workCostData]);

const districtOptions = useMemo(() => {
  return [...new Set(
    (Array.isArray(workCostData) ? workCostData : [])
      .map(item => item.talulka || item.District)
      .filter(Boolean)
      .map(district => district.split("-")[0].trim())
  )].sort();
}, [workCostData]);

const headCodeOptions = useMemo(() => {
  return [...new Set(
    (Array.isArray(workCostData) ? workCostData : [])
      .map(item => item.HeadCode)
      .filter(Boolean)
  )].sort();
}, [workCostData]);

const workOrderFilteredData = useMemo(() => {
  let data = [...(workOrdersData || [])];

  // Taluka filter
  if (selectedTaluka) {
    data = data.filter(
      (item) =>
        normalizeText(item.Taluka || item.ulb || item.talulka || item.District) ===
        normalizeText(selectedTaluka)
    );
  }

  // HeadCode filter
  if (selectedHeadCode) {
    data = data.filter(
      (item) =>
        normalizeText(item.HeadCode) ===
        normalizeText(selectedHeadCode)
    );
  }

  // Random Search
  if (workCostSearch.trim()) {
    const search = normalizeText(workCostSearch);

    data = data.filter((item) => {
      const combined = normalizeText(`
        ${item.Taluka || item.ulb || ""}
        ${item.talulka || item.District || ""}
        ${item.HeadCode || ""}
        ${item.WorkName || ""}
        ${item.TechnicalUID || ""}
        ${item.MHUID || ""}
        ${item.ApprovedWorkAmount || ""}
      `);

      return combined.includes(search);
    });
  }

  return data;
}, [
  workOrdersData,
  selectedTaluka,
  selectedHeadCode,
  workCostSearch,
  selectedDistrict
]);


const billSummaryFilteredData = useMemo(() => {
  let data = [...(billSummaryData || [])];

  // State-level roles → District filter
  if ([40, 41, 24, 25, 29].includes(RoleID)) {
    if (selectedDistrict) {
      const selected = normalizeText(selectedDistrict);
      data = data.filter((item) => {
        const itemDistrict = normalizeText(item.District);
        return (
          itemDistrict === selected ||
          itemDistrict.startsWith(`${selected}-`)
        );
      });
    }
  }

  // Other roles → Taluka filter
  else {
    if (selectedTaluka) {
      data = data.filter(
        (item) =>
          normalizeText(item.Taluka || item.ulb) ===
          normalizeText(selectedTaluka)
      );
    }
  }

  // Random Search
  if (billSummarySearch.trim()) {
    const search = normalizeText(billSummarySearch);

    data = data.filter((item) => {
      const combined = normalizeText(`
        ${item.District || ""}
        ${item.Taluka || item.ulb || ""}
        ${item.TotalBillAmount || ""}
      `);

      return combined.includes(search);
    });
  }

  return data;
}, [
  billSummaryData,
  selectedDistrict,
  selectedTaluka,
  billSummarySearch,
  RoleID,
]);

const billDetailsFilteredData = useMemo(() => {
  let data = [...(billDetailsData || [])];

  // Taluka filter
  if (selectedTaluka) {
    data = data.filter(
      (item) =>
        normalizeText(item.ulb) ===
        normalizeText(selectedTaluka)
    );
  }

  // Random Search
  if (billDetailsSearch.trim()) {
    const search = normalizeText(billDetailsSearch);

    data = data.filter((item) => {
      const combined = normalizeText(`
        ${item.DemandGenerationID || ""}
        ${item.RABillNumber || ""}
        ${item.ProjectName || ""}
        ${item.District || ""}
        ${item.ulb || ""}
        ${item.ContractorName || ""}
        ${item.BillAmount || ""}
        ${item.NetPayableAmount || ""}
        ${item.DeductionAmount || ""}
        ${item.Date || ""}
      `);

      return combined.includes(search);
    });
  }

  return data;
}, [
  billDetailsData,
  selectedTaluka,
  billDetailsSearch,
]);
const deductionSummaryFilteredData = useMemo(() => {
  let data = [...(billSummaryData || [])];

  // RoleID 40,41,24,25,29 → District filter
  if ([40, 41, 24, 25, 29].includes(RoleID)) {
    if (selectedDistrict) {
      data = data.filter(
        (item) =>
          normalizeText(item.District) ===
          normalizeText(selectedDistrict)
      );
    }
  }

  // Other roles → Taluka filter
  else {
    if (selectedTaluka) {
      data = data.filter(
        (item) =>
          normalizeText(item.Taluka || item.ulb) ===
          normalizeText(selectedTaluka)
      );
    }
  }

  // Random Search
  if (deductionSummarySearch.trim()) {
    const search = normalizeText(deductionSummarySearch);

    data = data.filter((item) => {
      const combined = normalizeText(`
        ${item.District || item.talulka || ""}
        ${item.Taluka || item.ulb || ""}
        ${item.DeductionAmount || ""}
      `);

      return combined.includes(search);
    });
  }

  return data;
}, [
  billSummaryData,
  selectedDistrict,
  selectedTaluka,
  deductionSummarySearch,
  RoleID,
]);

  // ── Pagination ────────────────────────────────────────────────────────────
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const tableData = useMemo(() => {
    console.log("showspecific:", showspecific);

    switch (showspecific) {
      case 1:
        console.log("Using workCostData", workCostData);
        return workCostFilteredData || [];

      case 4:
        console.log("Using workOrdersData", workOrderFilteredData );
        return workOrderFilteredData  || [];

      case 5:
        return billSummaryFilteredData  || [];

      case 6:
        return billDetailsFilteredData  || [];

      case 7:
        return deductionSummaryFilteredData   || [];

      default:
        return vendorbills || [];
    }
  }, [
    showspecific,
    vendorbills,
    workCostData,
    workCostFilteredData,
    workOrdersData,
    workOrderFilteredData ,
    billSummaryData,
    billSummaryFilteredData ,
    billDetailsData,
    billDetailsFilteredData ,
    deductionSummaryFilteredData 
  ]);

  const totalPages = useMemo(
    () => Math.ceil(tableData.length / billsPerPage),
    [tableData]
  );

  const currentTableData = useMemo(() => {
    const start = (currentPage - 1) * billsPerPage;
    return tableData.slice(start, start + billsPerPage);
  }, [tableData, currentPage]);

  const formatINR = useCallback((amount) => {
    const value = Number(amount);
    if (isNaN(value)) return "0";
    return value.toLocaleString("en-IN");
  }, []);

//--> old code
  // const formatINR = useCallback((amount) => {
  //   amount = Number(amount);
  //   if (isNaN(amount)) return "0";
  //   if (amount >= 10000000) return (amount / 10000000) + " Cr";
  //   if (amount >= 100000) return (amount / 100000) + " Lakh";
  //   return amount.toLocaleString("en-IN");
  // }, []);

  const getApprovalStatus = useCallback((bill) => {
    if (bill.Approvance1 === "false") return "Department Auditor Approval Pending";
    if (bill.Approvance2 === "false") return "Department HOD(EE) Approval Pending";
    if (bill.Approvance3 === "false") return "FD Auditor Approval Pending";
    if (bill.Approvance4 === "false") return "FD AAO Approval Pending";
    if (bill.Approvance5 === "false") return "FD AO Approval Pending";
    if (bill.Approvance6 === "false") return "Deputy CAFO Approval Pending";
    if (bill.Approvance7 === "false") return "CAFO Approval Pending";
    return bill.Status;
  }, []);

  // ── Initial load: menu + proposals + tax amounts (parallel) ──────────────
  useEffect(() => {
    if (initialLoadDone.current) return;
    initialLoadDone.current = true;

    const init = async () => {
      try {
        // Run menu fetch and proposal fetch in parallel
        const [menuData, proposalData] = await Promise.all([
          Usermenu(),
          GetProjectInfo('null', "GetALLProposal"),

        ]);

        // Process menu
        if (menuData && typeof menuData === "object") {
          const roleID = menuData?.Data?.RoleID;
          console.log("Usermenu() Admin Details ::", menuData);
          setroleID(roleID);

          // Fetch tax amounts based on role
        //   if (roleID === 40 || roleID === 41 || roleID === 24 || roleID === 25 || RoleID === 29) {
        //     GetAmountOfTaxes("State");
        //   }
        // }
            // Get HeadCodes assigned to logged-in user
          let headCodes = menuData?.Data?.HeadCode || [];
          console.log("Usermenu HeadCode:", menuData?.Data?.HeadCode);
 
          if (typeof headCodes === "string") {
            try {
              headCodes = JSON.parse(headCodes);
            } catch (error) {
              console.error("Invalid HeadCode format:", headCodes);
              headCodes = [];
            }
          }
 
          if (!Array.isArray(headCodes)) {
            headCodes = [headCodes];
          }
 
          headCodes = headCodes.filter(
            (headCode) =>
              headCode !== null &&
              headCode !== undefined &&
              String(headCode).trim() !== ""
          );
 
         
// DepartmentAccessID comes as a string like "[2]"
let departmentAccessIDs = menuData?.Data?.DepartmentAccessID || [];

if (typeof departmentAccessIDs === "string") {
  try {
    departmentAccessIDs = JSON.parse(departmentAccessIDs);
  } catch (error) {
    departmentAccessIDs = [];
  }
}

if (!Array.isArray(departmentAccessIDs)) {
  departmentAccessIDs = [departmentAccessIDs];
}

const uniqueDeptIDs = [...new Set(departmentAccessIDs.map(Number))];

// Hide 3054 only when DepartmentAccessID is exactly [2]
const isOnlyDepartment2 =
  uniqueDeptIDs.length === 1 && uniqueDeptIDs[0] === 2;

if (isOnlyDepartment2) {
  headCodes = headCodes.filter(
    (headCode) => !String(headCode).trim().startsWith("3054")
  );
}

setAllowedHeadCodes(headCodes);
 
          console.log("Logged-in User HeadCodes:", headCodes);
        }

        // Process proposals
        if (proposalData) {
          console.log("proposalData shape:", proposalData);
          setnewData(proposalData);
        }



      } catch (err) {
        console.error("Init error:", err);
      }
    };

    init();
  }, []); // eslint-disable-line

//   useEffect(() => {
//   if (!allowedHeadCodes.length) return;
 
//   const firstHeadCode = String(allowedHeadCodes[0]);
 
//   if (firstHeadCode.startsWith("3054")) {
//     settypeofData("District");
//   } else if (firstHeadCode.startsWith("2515")) {
//     settypeofData("State");
//   }
// }, [allowedHeadCodes]);



useEffect(() => {
  if (!allowedHeadCodes.length) return;

  const hasDistrict = allowedHeadCodes.some(
    (code) => String(code).startsWith("3054")
  );

  const hasState = allowedHeadCodes.some(
    (code) => String(code).startsWith("2515")
  );

  if (hasDistrict && hasState) {
    settypeofData("");
  } else if (hasDistrict) {
    settypeofData("District");
  } else if (hasState) {
    settypeofData("State");
  }
}, [allowedHeadCodes]);


  useEffect(() => {
    const fetchExistingWorkOrders = async () => {
      if (!typeofData) return;

      const data = await GetProjectInfo(
        "",
        "ExistingWorkOrders",
        typeofData
      );

      setExistingData(data || []);
      console.log("ExistingWorkOrders API:", data);
    };

    fetchExistingWorkOrders();
  }, [typeofData]);

  // // Overall Dashboard Data (Initial Load)
  // useEffect(() => {
  //   const loadOverallDashboard = async () => {
  //     try {
  //       const overallData = await GetDateWiseData("", "DashboardOverall", typeofData);
  //       setDateData(overallData || {});
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   loadOverallDashboard();
  // }, []);

  // ── Chart data: only re-fetch when selectedYear changes ──────────────────
  useEffect(() => {
    fetchChartData();
  }, [selectedYear, selectedWorkOrderType, selectedExistingWorkOrder,projectId,typeofData]); // eslint-disable-line

  const fetchChartData = async () => {
    try {
      setChartLoading(true);
      // Run all 4 in parallel




      const [proposaldata, techincalData, workOrderData, billData, physicalProgressData] = await Promise.all([
        GetProposallist("ProposalChart", typeofData, projectId),
        TechnicalOutwards("TechnicalDashboard","", typeofData,projectId), 
        WorkOutwards(selectedWorkOrderType || "" , typeofData,"WorkOrderChart",projectId),
        TechnicalOutwards("BillChart",selectedWorkOrderType === "Overall" ? "" : selectedWorkOrderType, typeofData,projectId),
        TechnicalOutwards("PhysicalProgressChart", selectedWorkOrderType, typeofData,projectId)
      ]);


      const filteredProposals = (proposaldata?.message || proposaldata || []).filter(
        (item) => projectId || selectedYear === "All" || item.Proposal_year === selectedYear
      );
      const filteredTechnical = (techincalData?.message || techincalData || []).filter(
        (item) => projectId || selectedYear === "All" || item.SanctionYear === selectedYear
      );
      const filteredWorkorder = (workOrderData?.message || workOrderData || []).filter(
        (item) =>  projectId || selectedYear === "All" || item.ProposalYear === selectedYear
      );
      const filteredBills = (billData?.message || billData || []).filter(
        (item) => projectId || selectedYear === "All" || item.ProposalYear === selectedYear
      );

      const filteredPhysicalProgress =
        (physicalProgressData?.message || physicalProgressData || []).filter(
          (item) => projectId || selectedYear === "All" || item.ProposalYear === selectedYear
        );
      console.log("physicalProgressData", physicalProgressData);
      console.log("Bill API Response:", billData);
      console.log("Bill Count:", billData?.message?.length || billData.length);
      if (selectedWorkOrderType === "Existing Work Order") {
        console.log("Existing Bills", filteredBills);

        setProposalCount(0);

        setTechnicalCount(filteredPhysicalProgress.length || 0);

        setWorkorderCount(filteredWorkorder.length || 0);

        setBillCount(filteredBills.length || 0);

      } else {

        setProposalCount(filteredProposals.length || 0);
        setTechnicalCount(filteredTechnical.length || 0);
        setWorkorderCount(filteredWorkorder.length || 0);
        setBillCount(filteredBills.length || 0);
        setUserRole(proposaldata?.Tabletype || "");
      }
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setChartLoading(false);
    }
  };

  const GetAmountOfTaxes = useCallback(async (type) => {
    try {
      const data = await GetTaxAmounts(type);
      SetData(data || {});
    } catch (error) {
      console.error("Error fetching tax amounts:", error);
      SetData({});
    }
  }, [GetTaxAmounts]);

  // ── Filtered data: recompute when typeofData, newData, RoleID, or debouncedSearch changes ──
  useEffect(() => {
    if (!newData || newData.length === 0) {
      setFilteredData([]);
      setBaseData([]);
      return;
    }

    let filtered = [...newData];

    // HeadCode filter
    if ([14, 15, 16, 17, 18, 19, 20, 22, 27, 28, 29, 31].includes(RoleID)) {
      if (typeofData === "District") {
        filtered = filtered.filter(item =>
          item.HeadCode === "3054-2419(Roads and bridge repair maintenance program)"
        );
      } else if (typeofData === "State") {
        filtered = filtered.filter(item =>
          item.HeadCode === "2515-1238(MLA Representative)"
        );
      }
    }

    setBaseData(filtered);

    // Search filter
    if (debouncedSearch && debouncedSearch.trim()) {
      const search = normalizeText(debouncedSearch);
      filtered = filtered.filter((item) => {
        const combined = normalizeText(`${item.TechnicalSanctionNo} (${item.Work_name})`);
        return combined.includes(search);
      });
    }

    setFilteredData(filtered);

    // Tax amounts fetch (only when typeofData changes, not on every search)
  }, [typeofData, newData, RoleID]); // eslint-disable-line

  // ── Search filter only (debounced, uses baseData) ─────────────────────────
  useEffect(() => {
    if (!debouncedSearch.trim()) {
      setFilteredData(baseData);
      return;
    }
    const search = normalizeText(debouncedSearch);
    setFilteredData(
      baseData.filter((item) => {
        const combined = normalizeText(`${item.TechnicalSanctionNo || ""} (${item.Work_name || ""})`);
        return combined.includes(search);
      })
    );
  }, [debouncedSearch, baseData]);

  // ── Tax amount fetch when typeofData changes ──────────────────────────────
  useEffect(() => {
    if (!RoleID) return;
    const stateRoles = [40, 41, 24, 25];
    const restrictedRoles = [14, 15, 16, 17, 18, 19, 20, 22, 27, 28, 29, 31];

    if (restrictedRoles.includes(RoleID)) {
      GetAmountOfTaxes(typeofData);
    } else if (stateRoles.includes(RoleID)) {
      GetAmountOfTaxes("State");
    } else {
      GetAmountOfTaxes("");
    }
  }, [typeofData, RoleID]); // eslint-disable-line

  // ── Reset MHUID-related state when typeofData changes (user-driven only) ──
  useEffect(() => {
    if (isAutoSettingHeadcode.current) {
      isAutoSettingHeadcode.current = false;
      return;
    }
    if (!projectId) return;
    const selectedItem = newData.find((item) => item.Work_name === projectId);
    if (!selectedItem) return;
    const headCode = selectedItem.HeadCode || "";
    const mismatch =
      (typeofData === "District" && !headCode.startsWith("3054")) ||
      (typeofData === "State" && !headCode.startsWith("2515"));
    if (mismatch) {
      setProjectId("");
      setSearchTerm("");
      setMHUID("");
    }
  }, [typeofData]); // eslint-disable-line

  // ── When projectId changes: fetch all project-specific data in parallel ───

  // ── When selection changes: fetch dashboard/project data ───────────────────
  useEffect(() => {
    const fetchProjectData = async () => {
      setloading(true);

      try {
        console.log("selectedWorkOrderType :", selectedWorkOrderType);
        console.log("projectId :", projectId);
        console.log("selectedExistingWorkOrder :", selectedExistingWorkOrder);

        let dashboardPromise;

        // ================= Dashboard API =================
        if (!selectedWorkOrderType) {
          dashboardPromise = GetDateWiseData("", "DashboardOverall", typeofData);
        }
        else if (selectedWorkOrderType === "New Work Order") {

          if (projectId) {
            dashboardPromise = GetDateWiseData(projectId, "NewProjectfetching", typeofData);
          } else {
            dashboardPromise = GetDateWiseData("", "DashboardNewOverall", typeofData);
          }

        }
        else if (selectedWorkOrderType === "Existing Work Order") {

          if (selectedExistingWorkOrder) {
            dashboardPromise = GetDateWiseData(
              selectedExistingWorkOrder,
              "ExistingProjectFetching", typeofData
            );
          } else {
            dashboardPromise = GetDateWiseData("", "DashboardExistingOverall", typeofData);
          }

        }

        // Fetch dashboard first
        const dateDataRes = await dashboardPromise;
        console.log("==================================");
        console.log("API TYPE :", selectedWorkOrderType);
        console.log("typeofData :", typeofData);
        console.log("projectId :", projectId);
        console.log("Existing :", selectedExistingWorkOrder);
        console.log("dateDataRes :", dateDataRes);
        console.log("==================================");

        setDateData(dateDataRes || []);

        // ================= Overall Dashboard =================

        if (!projectId && !selectedExistingWorkOrder) {

          const workCostRes = await GetTotalTableData(
            "",
            "OverallWorkCostData",
            typeofData,
            selectedWorkOrderType
          );

          console.log("OverallWorkCostData response:", workCostRes);
          console.log("Response is array:", Array.isArray(workCostRes));

          const workCostRows = Array.isArray(workCostRes)
            ? workCostRes
            : Array.isArray(workCostRes?.message)
              ? workCostRes.message
              : [];

          setWorkCostData(workCostRows);
          setWorkOrdersData(workCostRows);

          setLimitAllotedData([]);
          setAmountReleasedData([]);
          setVendorBills([]);
          setDeductionData([]);
          setHeadFetchedData([]);
          setOverlappingData([]);
          setCurrentPage(1);

          return;
        }

        const selectedId =
          selectedWorkOrderType === "Existing Work Order"
            ? selectedExistingWorkOrder
            : projectId;

        console.log("selectedExistingWorkOrder:", selectedExistingWorkOrder);
        console.log("selectedWorkOrderType:", selectedWorkOrderType);

        // ================= Project APIs =================
        const [
          workCostRes,
          limitRes,
          amountReleasedRes,
          workOrdersRes,
          vendorBillsRes,
          deductionRes,
          headRes,
          overlapRes,
        ] = await Promise.all([
          !projectId && !selectedExistingWorkOrder
            ? GetTotalTableData(
              "",
              "OverallWorkCostData",
              typeofData,
              selectedWorkOrderType
            )
            : GetTotalTableData(
              selectedId,
              selectedWorkOrderType === "Existing Work Order"
                ? "ExistingWorkCostData"
                : "WorkCostData",
              typeofData,
              selectedWorkOrderType
            ),
          GetTotalTableData(selectedId, "LimitAllotedData"),
          GetTotalTableData(selectedId, "AmountReleasedData"),
          !projectId && !selectedExistingWorkOrder
            ? GetTotalTableData(
              "",
              "OverallWorkCostData",
              typeofData,
              selectedWorkOrderType
            )
            : GetTotalTableData(
              selectedId,
              "WorkOrdersData",
              typeofData,
              selectedWorkOrderType
            ),
          GetVendorBills(),
          GetDateWiseData(selectedId, "deductionFetching", typeofData),
          GetProjectInfo(selectedId, "getprojectHeadEstimationamount"),
          GetOverLappingData(proposalUID),
        ]);

        setWorkCostData(workCostRes || []);
        console.log("workCostRes:", workCostRes);
        console.log("workCostData state will be:", workCostRes || []);
        setLimitAllotedData(limitRes || []);
        setAmountReleasedData(amountReleasedRes || []);
        setWorkOrdersData(workOrdersRes || []);

        // ================= Vendor Bills =================
        if (vendorBillsRes) {
          let filtered = [];

          if (selectedWorkOrderType === "New Work Order") {
            filtered = vendorBillsRes.filter(
              (item) => item.WorkUniqueID === projectId && item.TypeOfAmount === "Total Amount Payable" && item. Status !=="Rejected"
            );
          }
          else if (selectedWorkOrderType === "Existing Work Order") {
            filtered = vendorBillsRes.filter(
              (item) => item.WorkOrderID === selectedExistingWorkOrder && item.TypeOfAmount === "Total Amount Payable" && item. Status !=="Rejected"
            );
          }

          setVendorBills(filtered);
        }

        setDeductionData(deductionRes || []);
        setHeadFetchedData(headRes || []);
        setOverlappingData(overlapRes || []);
        setCurrentPage(1);

      } catch (err) {
        console.error("Error fetching project data:", err);
      } finally {
        setloading(false);
      }
    };

    fetchProjectData();

  }, [
    projectId,
    selectedWorkOrderType,
    selectedExistingWorkOrder,
    typeofData
  ]);

  // ── Charts state ──────────────────────────────────────────────────────────
  const [state, setState] = React.useState({
    series: [
      { name: "High - 2013", data: [28, 29, 33, 36, 32, 32, 33] },
      { name: "Low - 2013", data: [12, 11, 14, 18, 17, 13, 13] },
    ],
    options: {
      chart: { height: 350, type: 'line', dropShadow: { enabled: true, color: '#000', top: 18, left: 7, blur: 10, opacity: 0.5 }, zoom: { enabled: false }, toolbar: { show: false } },
      colors: ['#442cfe', '#50bdf5'],
      dataLabels: { enabled: true },
      stroke: { curve: 'smooth' },
      grid: { borderColor: '#e7e7e7', row: { colors: ['#f3f3f3', '#f9f9f9'], opacity: 0.5 } },
      markers: { size: 5, colors: ['#77B6EA', '#545454'], strokeWidth: 2 },
      tooltip: { enabled: true, theme: 'dark' },
      animations: { enabled: true, easing: 'easeinout', speed: 800, animateGradually: { enabled: true, delay: 150 } },
      xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'] },
      yaxis: { min: 5, max: 40, labels: { show: false } },
      legend: { show: false },
      responsive: [{ breakpoint: 600, options: { chart: { height: 300 }, legend: { position: 'bottom' } } }],
    },
  });

  const [state1, setState1] = React.useState({
    series: [
      { name: 'PRODUCT A', data: [44, 55, 41, 67, 22, 43] },
      { name: 'PRODUCT B', data: [13, 23, 20, 8, 13, 27] },
      { name: 'PRODUCT C', data: [11, 17, 15, 15, 21, 14] },
      { name: 'PRODUCT D', data: [21, 7, 25, 13, 22, 8] },
    ],
    options: {
      chart: { type: 'bar', height: 350, stacked: true, toolbar: { show: false }, zoom: { enabled: true } },
      responsive: [{ breakpoint: 480, options: { legend: { position: 'bottom', offsetX: -10, offsetY: 0 } } }],
      plotOptions: { bar: { horizontal: false, borderRadius: 10, dataLabels: { total: { enabled: true, style: { fontSize: '13px', fontWeight: 900 } } } } },
      xaxis: { type: 'datetime', categories: ['01/01/2011 GMT', '01/02/2011 GMT', '01/03/2011 GMT', '01/04/2011 GMT', '01/05/2011 GMT', '01/06/2011 GMT'] },
      yaxis: { labels: { show: false } },
      legend: { show: false },
      fill: { opacity: 1 },
      colors: ['#442cfe', '#5937fd', '#50bdf5', '#cad1e0'],
    },
  });

  const [state2, setState2] = React.useState({
    series: [44, 55, 15],
    options: {
      chart: { type: 'donut', width: 200, height: 200 },
      labels: [],
      colors: ['#442cfe', '#50bdf5', '#ee574c'],
      legend: { show: false },
      dataLabels: { enabled: false },
      responsive: [{ breakpoint: 480, options: { chart: { width: 100, height: 100 }, legend: { position: 'bottom', show: false } } }],
    },
  });

  // PIE CHART 1 — memoized series
  const pieChart1Series = useMemo(() => {
    if (selectedWorkOrderType === "Existing Work Order") {
      return [
        Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount ?? 0),          // Total Bill Amount
        Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount ?? 0),// Total Deduction
        Number(dateData?.Project_Cost ?? getData?.Project_Cost ?? 0),                // Total Work Cost
        Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders ?? 0),          // Total Work Orders
      ];
    }

    // New Work Order
    return [
      Number(dateData?.Project_Cost ?? getData?.Project_Cost ?? 0),
      Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount ?? 0),
      Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount ?? 0),
    ];
  }, [selectedWorkOrderType, getData, dateData]);

  const state4 = useMemo(() => ({
    series: pieChart1Series,
    options: {
      chart: {
        width: 380,
        type: "pie",
      },
      labels:
        selectedWorkOrderType === "Existing Work Order"
          ? [
            "Total Bill Amount",
            "Total Deduction Amount",
            "Total Work Cost",
            "Total Work Orders",
          ]
          : [
            "Project Cost",
            "Total Deduction Amount",
            "Total Bill Amount",
          ],
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "14px",
        markers: {
          radius: 12,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 200 },
            legend: { position: "bottom" },
          },
        },
      ],
    },
  }), [pieChart1Series, selectedWorkOrderType]);

  // PIE CHART 2 — memoized
  const state5 = useMemo(() => {
    if (selectedWorkOrderType === "Existing Work Order") {
      return {
        series: [
          Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount ?? 0),
          Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount ?? 0),
          Number(dateData?.Project_Cost ?? getData?.Project_Cost ?? 0),
          Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders ?? 0),
        ],
        options: {
          chart: { width: 380, type: "pie" },
          labels: [
            "Total Bill Amount",
            "Total Deduction Amount",
            "Total Work Cost",
            "Total Work Orders",
          ],
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "14px",
            markers: { radius: 12 },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: { width: 200 },
                legend: { position: "bottom" },
              },
            },
          ],
        },
      };
    }

    if (!deductionData || deductionData.length === 0) {
      return {
        series: [],
        options: {
          chart: { width: 380, type: "pie" },
          labels: [],
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "14px",
            markers: { radius: 12 },
          },
        },
      };
    }

    return {
      series: deductionData.map(item => Number(item.TotalAmount)),
      options: {
        chart: { width: 380, type: "pie" },
        labels: deductionData.map(item => item.TypeOfAmount),
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "14px",
          markers: { radius: 12 },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { position: "bottom" },
            },
          },
        ],
      },
    };
  }, [deductionData, selectedWorkOrderType, getData, dateData]);
  // ── Bar chart options (memoized) ──────────────────────────────────────────
  const barChartOptions = useMemo(() => {

    const isExisting =
      selectedWorkOrderType === "Existing Work Order";

    return {
      title: {
        text: t("Project Statistics")
      },

      toolbar: {
        show: false
      },

      colors: isExisting
        ? ['#064fcf', '#fd7e14', '#01b574']
        : ['#064fcf', '#fd7e14', '#01b574', '#a3aed0'],

      plotOptions: {
        bar: {
          columnWidth: "40%",
          distributed: true,
          borderRadius: 18,
          borderRadiusApplication: "end",
        },
      },
      grid: {
        borderColor: "#E8ECF3",
        strokeDashArray: 5,
      },

      legend: {
        position: "top",
        horizontalAlign: "center",
      },

      dataLabels: {
        enabled: false,
      },

      stroke: {
        show: false,
      },

      xaxis: {
        categories: isExisting
          ? [
            t("Work Order"),
            t("Physical Progress"),
            t("Bill"),
          ]
          : [
            t("Proposal"),
            t("Technical"),
            t("Work Order"),
            t("Bills"),
          ],
      },

      yaxis: {
        title: {
          text: t("Count"),
        },
      },
    };

  }, [selectedWorkOrderType, t]);

  const barChartSeries = useMemo(() => {

    const isExisting =
      selectedWorkOrderType === "Existing Work Order";

    return [{
      name: t("Count"),
      data: isExisting
        ? [
          workorderCount,
          technicalCount,
          billCount,
        ]
        : [
          proposalCount,
          technicalCount,
          workorderCount,
          billCount,
        ],
    }];

  }, [
    proposalCount,
    technicalCount,
    workorderCount,
    billCount,
    selectedWorkOrderType,
    t,
  ]);

  // ── Export helpers ────────────────────────────────────────────────────────
  const exportTableByClassToExcel = (classname, filename = "Export.xlsx") => {
    const table = document.querySelector(`.${classname}`);
    if (!table) { alert("Table not found!"); return; }
    const worksheet = XLSX.utils.table_to_sheet(table);
    const numCols = table.rows[0].cells.length;
    worksheet['!cols'] = Array(numCols).fill({ wch: 20 });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, filename);
  };

  const downloadPageAsPDF = async (tableClass, chartClass, filename, title) => {
    setloading(true);
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      let currentY = 15;
      if (title) {
        pdf.setFontSize(18); pdf.setFont(undefined, 'bold');
        pdf.text(title, pageWidth / 2, currentY, { align: 'center' });
        currentY += 10;
      }
      const originalShowGraph = showGraph;
      let chartAdded = false;
      if (originalShowGraph !== "Chart") { setShowGraph("Chart"); await new Promise(r => setTimeout(r, 500)); }
      const chartElement = document.querySelector(`.${chartClass}`);
      if (chartElement && isElementVisible(chartElement)) {
        pdf.setFontSize(14); pdf.text('Chart View', pageWidth / 2, currentY, { align: 'center' }); currentY += 5;
        const chartCanvas = await html2canvas(chartElement, { scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff' });
        const chartImgData = chartCanvas.toDataURL('image/png');
        const chartWidth = pageWidth - 20;
        const chartHeight = (chartCanvas.height * chartWidth) / chartCanvas.width;
        if (chartHeight > pageHeight - currentY - 10) {
          pdf.addPage('l');
          const lW = pdf.internal.pageSize.getWidth(); const lH = pdf.internal.pageSize.getHeight();
          currentY = 15; pdf.setFontSize(14); pdf.text('Chart View', lW / 2, currentY, { align: 'center' }); currentY += 5;
          const aW = lW - 20; const aH = (chartCanvas.height * aW) / chartCanvas.width;
          pdf.addImage(chartImgData, 'PNG', 10, currentY, aW, Math.min(aH, lH - 25));
        } else {
          pdf.addImage(chartImgData, 'PNG', 10, currentY, chartWidth, chartHeight); currentY += chartHeight + 10;
        }
        chartAdded = true;
      }
      setShowGraph("Table"); await new Promise(r => setTimeout(r, 500));
      const tableElement = document.querySelector(`.${tableClass}`);
      let tableAdded = false;
      if (tableElement && isElementVisible(tableElement)) {
        if (chartAdded) { pdf.addPage('p'); } else { pdf.setPage(1); }
        currentY = 15; pdf.setFontSize(14); pdf.text('Table View', pdf.internal.pageSize.getWidth() / 2, currentY, { align: 'center' }); currentY += 5;
        const tableCanvas = await html2canvas(tableElement, { scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff' });
        const tableImgData = tableCanvas.toDataURL('image/png');
        const tableWidth = pdf.internal.pageSize.getWidth() - 20;
        const tableHeight = (tableCanvas.height * tableWidth) / tableCanvas.width;
        pdf.addImage(tableImgData, 'PNG', 10, currentY, tableWidth, tableHeight);
        tableAdded = true;
      }
      setShowGraph(originalShowGraph);
      if (!chartAdded && !tableAdded) { alert('No content found to export!'); return; }
      const totalPgs = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPgs; i++) {
        pdf.setPage(i);
        const cpw = pdf.internal.pageSize.getWidth(); const cph = pdf.internal.pageSize.getHeight();
        pdf.setFontSize(8); pdf.setTextColor(128);
        pdf.text(`Generated on: ${new Date().toLocaleDateString()} | Page ${i} of ${totalPgs}`, cpw / 2, cph - 5, { align: 'center' });
      }
      pdf.save(filename); alert('PDF downloaded successfully!');
    } catch (error) {
      console.error('Error generating PDF:', error); alert('Failed to download PDF.');
    } finally {
      setloading(false);
    }
  };

  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    setExportingPDF(true);
    await new Promise(res => setTimeout(res, 300));
    const table = document.querySelector(`.${tableClass}`);
    if (!table) { setExportingPDF(false); return; }
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    pdf.setFontSize(16); pdf.setFont("helvetica", "bold");
    pdf.text(title, pageWidth / 2, 15, { align: "center" });
    const canvas = await html2canvas(table, { scale: 2, useCORS: true, backgroundColor: "#fff" });
    const imgData = canvas.toDataURL("image/png");
    const imgWidth = pageWidth - 20;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight; let position = 25;
    pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
    while (heightLeft > 0) {
      position = heightLeft - imgHeight + 25; pdf.addPage();
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    pdf.save(filename); setExportingPDF(false);
  };


  const combinedData = [
    ...(newData || []),
    ...(existingData || [])
  ];

  const searchResults = useMemo(() => {
  const s = normalizeText(debouncedSearch || "");
  if (!s) return [];

  const newItems =
    selectedWorkOrderType === "Existing Work Order"
      ? []
      : (filteredData || []).map((i) => ({ ...i, _type: "New Work Order" }));

  const existingItems =
    selectedWorkOrderType === "New Work Order"
      ? []
      : (existingData || [])
          .filter((i) =>
            normalizeText(`${i.WorkOrderID} ${i.WorkName}`).includes(s)
          )
          .map((i) => ({ ...i, _type: "Existing Work Order" }));

  return [...newItems, ...existingItems];
}, [debouncedSearch, filteredData, existingData, selectedWorkOrderType]);

const applySearchSelection = (item) => {
  if (item._type === "Existing Work Order") {
    setSelectedWorkOrderType("Existing Work Order");
    setSelectedExistingWorkOrder(item.WorkOrderID);
    setProjectId(item.WorkOrderID);          // same ID everywhere
    setProposalUID("");
    setMHUID("");
    setSearchTerm(`${item.WorkOrderID} (${item.WorkName})`);
  } else {
    const newType = item.HeadCode?.startsWith("3054")
      ? "District"
      : item.HeadCode?.startsWith("2515")
      ? "State"
      : typeofData;

    // only flag auto-set if the value will actually change
    if (newType !== typeofData) {
      isAutoSettingHeadcode.current = true;
      settypeofData(newType);
    }

    setSelectedWorkOrderType("New Work Order");
    setSelectedExistingWorkOrder("");
    setProjectId(item.Work_name);
    setProposalUID(item.ProposalID);
    setMHUID(item.TechnicalSanctionNo);
    setSearchTerm(`${item.TechnicalSanctionNo} (${item.Work_name})`);
    if (item.Proposal_year) setSelectedYear(item.Proposal_year);
  }
  setShowList(false);
};

  const showHeadDetails =
    selectedWorkOrderType !== "Existing Work Order" &&
    headFetchedData;

  const isLargeAmount =
    String(Number(dateData?.LiabalityAmount ?? 0)).length > 10 ||
    String(Number(dateData?.TotalDeductionAmount ?? 0)).length > 10 ||
    String(Number(dateData?.Project_Cost ?? getData?.Project_Cost ?? 0)).length > 9;

  // ── Render ────────────────────────────────────────────────────────────────
 
   const pagetotalpaidamt1 = currentTableData?.reduce((sum, item) => {
    const amount = Number(item.ApprovedWorkAmount ||
                                      item.Proposal_amount );
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
    const totalpaidamt1 = tableData?.reduce((sum, item) => {
    const amount = Number(item.ApprovedWorkAmount ||
                                      item.Proposal_amount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

    const pagetotalpaidamt2 = currentTableData?.reduce((sum, item) => {
    const amount = Number(item.TotalBillAmount );
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
    const totalpaidamt2 = tableData?.reduce((sum, item) => {
    const amount = Number(item.TotalBillAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  
  
console.log("Allowed HeadCodes:", allowedHeadCodes);
console.log("Selected Head Code:", typeofData);
  return (
    <>
      <div style={{ backgroundColor: '#f4f7fc', padding: '20px', overflowY: 'scroll', height: '90vh' }}>

        {showspecific === 0 && (
          <>
            <div><h1 className="dashboard-title">{t("Project Dashboard")}</h1></div>

            {(newData?.length > 0 || existingData?.length > 0 || barChartSeries?.[0]?.data?.some((val) => val > 0)) ? (
              <div className="dashboardFilterContainer">
                <div className="dashboardFilterRow"
                >
                  {[14, 15, 16, 17, 18, 19, 20, 22, 27, 28, 29, 31].includes(RoleID) && (
                    <div className="dashboardFilterItem">
                      <label style={{ fontWeight: "600" }}>{t("Select Head Code")}</label>
                      <select
                        value={typeofData}
                        className="form-control"
                        onChange={(e) => {
                          settypeofData(e.target.value);
                          setMHUID(""); setProjectId(""); setSearchTerm("");
                        }}
                      >
                           <option value="" >
                          Select Head Code
                        </option>
 
            
{allowedHeadCodes.map((headCode, index) => {
  const code = String(headCode).trim();

  let value = "";

  if (code.startsWith("3054")) {
    value = "District";
  } else if (code.startsWith("2515")) {
    value = "State";
  }

  if (!value) return null;

  const matchingHeadCode = combinedData.find((item) =>
    String(item.HeadCode || "").startsWith(code)
  )?.HeadCode;

  const label =
    matchingHeadCode ||
    (code.startsWith("3054")
      ? "3054-2419(Roads and bridge repair maintenance program)"
      : "2515-1238(MLA Representative)");

  return (
    <option key={`${code}-${index}`} value={value}>
      {label}
    </option>
  );
})}
                      </select>
                    </div>
                  )}

                  <div className="dashboardFilterItem">
                    <label style={{ fontWeight: "700" }}>
                      Work Order Type
                    </label>

                    <select
                      className="form-control"
                      value={selectedWorkOrderType}
                      onChange={(e) => {
                        setSelectedWorkOrderType(e.target.value);

                        // Clear previous selection
                        setProjectId("");
                        setSelectedExistingWorkOrder("");   // add this
                        setProposalUID("");
                        setSearchTerm("");
                        setMHUID("");
                      }}
                      style={{ width: "180px" }}
                    >
                      <option value="">Select Work Order Type</option>
                      <option value="New Work Order">New Work Order</option>
                      <option value="Existing Work Order">Existing Work Order</option>
                    </select>
                  </div>

                  {selectedWorkOrderType === "New Work Order" && (
                    <div className="dashboardFilterItem">
                      <label style={{ fontWeight: "700", }}>{t("Select MHUID")}</label>
                      <select
                        name="projectId"
                        className="form-control"
                        value={projectId}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          const selectedItem = baseData.find((item) => item.Work_name === selectedValue);
                          if (selectedItem) {
                            console.log("Selected Item:", selectedItem);   
                            isAutoSettingHeadcode.current = true;
                            if (selectedItem.HeadCode?.startsWith("3054")) settypeofData("District");
                            else if (selectedItem.HeadCode?.startsWith("2515")) settypeofData("State");
                            setProjectId(selectedItem.Work_name);
                            console.log("Setting projectId:", selectedItem.Work_name);
                            setProposalUID(selectedItem.ProposalID);
                            setMHUID(selectedItem.TechnicalSanctionNo);
                            setSearchTerm(`${selectedItem.TechnicalSanctionNo} (${selectedItem.Work_name})`);
                            if (selectedItem.Proposal_year) setSelectedYear(selectedItem.Proposal_year);
                          } else {
                            setProjectId(""); setSearchTerm("");
                          }
                          setShowList(false);
                        }}

                      >
                        <option value="" disabled>{t("Please Select MHUID")}</option>
                        {baseData.map((item, index) => (
                          <option key={index} value={item.Work_name}>
                            {item.TechnicalSanctionNo} ({item.Work_name})
                          </option>
                        ))}
                      </select>
                    </div>

                  )}


                  {selectedWorkOrderType === "Existing Work Order" && (
                    <div className="dashboardFilterItem">
                      <label style={{ fontWeight: "700", }}>
                        Work Name
                      </label>

                      <select
                        className="form-control"
                        value={selectedExistingWorkOrder}
                        onChange={(e) => {
                          const value = e.target.value;

                          setSelectedExistingWorkOrder(value);

                          const selectedItem = existingData.find(
                            item => item.WorkOrderID === value
                          );

                          if (selectedItem) {
                            setProjectId(selectedItem.WorkOrderID);
                            console.log("ProjectId sent to API:", selectedItem.WorkOrderID);
                            setSearchTerm(selectedItem.WorkName);
                            setMHUID("");
                          } else {
                            setProjectId("");
                            setSearchTerm("");
                          }
                        }}

                      >
                        <option value="">Select Work Order</option>

                        {existingData.map((item, index) => (
                          <option key={index} value={item.WorkOrderID}>
                            {item.WorkName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}


                  <div className="dashboardFilterItem" style={{ position: "relative" }}>

                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <label style={{ fontWeight: "700" }}>{t("Search")}</label>

                      <input
                        type="text"
                        className="form-control"
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setShowList(true);
                        }}
                        onFocus={() => setShowList(true)}
                        placeholder={
                          selectedWorkOrderType === "Existing Work Order"
                            ? t("Search Work Order")
                            : t("Search Here")
                        }
                      />
                    </div>

                    {showList && searchTerm && searchResults.length > 0 && (
  <div
    style={{
      position: "absolute", top: "45px", left: "172px", width: "250px",
      maxHeight: "250px", overflowY: "auto", background: "white",
      border: "1px solid #ccc", borderRadius: "4px", zIndex: 1000,
    }}
  >
    {searchResults.map((item, index) => (
      <div
        key={index}
        style={{ padding: "8px", cursor: "pointer" }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f1f1")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
        onClick={() => applySearchSelection(item)}
      >
        {item._type === "Existing Work Order"
          ? `${item.WorkOrderID} (${item.WorkName})`
          : `${item.TechnicalSanctionNo} (${item.Work_name})`}
        <small style={{ display: "block", color: "#888" }}>
          {item._type}
        </small>
      </div>
    ))}
  </div>
)}

                  </div>
                </div>
              </div>
            ) : (
              <h4 style={{ textAlign: 'center' }}>{t("No Proposals Found")}</h4>
            )}

            {loading ? (
              <div className="Adminloader"></div>
            ) : (
              <>
                {(newData?.length > 0 || existingData?.length > 0 || barChartSeries?.[0]?.data?.some((val) => val > 0)) ? (

                  <>
                    {/* ── Summary cards ── */}
                    <div className={`dashboardSummary ${isLargeAmount ? "twoCards" : ""}`}>

                      {/* Total Work Cost */}
                      <div
                        onClick={() => {

                          const amount = Number(dateData?.Project_Cost ?? getData?.Project_Cost);

                          if (amount === 0) return;

                          setShowWorkCostTable(!showWorkCostTable);
                            setSelectedDistrict("");
                            setSelectedTaluka("");
                            setSelectedHeadCode("");
                            setWorkCostSearch("");
                            setBillSummarySearch("");
                            setBillDetailsSearch("");
                            setDeductionSummarySearch("");
                          setCurrentPage(1);
                          setShowSpecific(1);
                        }}
                        className="dashboardCard workCostCard"

                        style={{
                          cursor:
                            Number(dateData?.Project_Cost ?? getData?.Project_Cost) > 0
                              ? "pointer"
                              : "not-allowed",
                          opacity:
                            Number(dateData?.Project_Cost ?? getData?.Project_Cost) > 0
                              ? 1
                              : 0.6,
                        }}
                      >
                        <div className="cardContent">
                          <div className="cardIcon">
                            <img src={TotalProjectCost11} alt="" />
                          </div>

                          <div className="cardDetails">
                            <h6>{t("Total Work Cost")}</h6>
                            <h5>
                              {console.log("Current KPI Data", dateData)
                              }
                              ₹{" "}
                              {formatINR(dateData?.Project_Cost ?? getData?.Project_Cost
                              )}
                            </h5>
                          </div>

                          <div className="arrow-icon">
                            <img
                              src="/Arrow-Total-Original-Limit-Allocated.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>

                      {/* Total Work Orders */}
                      <div
                        onClick={() => {
                          const amount = Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders);

                          if (amount === 0) return;
                          setShowWorkOrdersTable(!showWorkOrdersTable);
                          setCurrentPage(1);
                          setShowSpecific(4);
                        }}
                        className="dashboardCard workOrderCard"
                        style={{
                          cursor:
                            Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders) > 0
                              ? "pointer"
                              : "not-allowed",
                          opacity:
                            Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders) > 0
                              ? 1
                              : 0.6,
                        }}
                      >
                        <div className="cardContent">
                          <div className="cardIcon">
                            <img src={TotalWorkOrders} alt="" />
                          </div>

                          <div className="cardDetails">
                            <h6>{t("Total Work Orders")}</h6>
                            <h5>
                              {formatINR(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders)}
                            </h5>
                          </div>

                          <div className="arrow-icon">
                            <img
                              src="/Arrow-Total-Original-Limit-Allocated.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>

                      {/* Total Bill Amount */}
                      <div
                        onClick={async () => {
                          const amount = Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount);

                          if (amount === 0) return;

                            console.log("Card Click:", {
                              projectId,
                              selectedExistingWorkOrder,
                              selectedWorkOrderType,
                            });

                            const selectedId =
                              selectedWorkOrderType === "Existing Work Order"
                                ? selectedExistingWorkOrder
                                : projectId;

                          const res = await GetDateWiseData(
                             selectedId,
                            "BillSummary",
                            typeofData,
                            selectedWorkOrderType,

                          );

                            setBillSummaryData(res);
                            setSelectedDistrict("");
                            setSelectedTaluka("");
                            setSelectedHeadCode("");
                            setWorkCostSearch("");
                            setBillSummarySearch("");
                            setBillDetailsSearch("");
                            setDeductionSummarySearch("");
                          setCurrentPage(1);
                          setShowSpecific(5);
                        }}
                        className="dashboardCard billCard"
                        style={{
                          cursor:
                            Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount) > 0
                              ? "pointer"
                              : "not-allowed",
                          opacity:
                            Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount) > 0
                              ? 1
                              : 0.6,
                        }}
                      >
                        <div className="cardContent">
                          <div className="cardIcon">
                            <img src={TotalBillAmount64} alt="" />
                          </div>

                          <div className="cardDetails">
                            <h6>{t("Total Bill Amount")}</h6>
                            <h5>
                              ₹{" "}
                              {(Number(
                                dateData?.LiabalityAmount ?? getData?.LiabalityAmount
                              ) || 0).toLocaleString("en-IN")}
                            </h5>
                          </div>
                          <div className="arrow-icon">
                            <img
                              src="/Arrow-Total-Original-Limit-Allocated.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>

                      {/* Total Deduction Amount */}
                      <div onClick={async () => {
                        console.log("Total Deduction Amount Clicked");
                        const amount = Number(
                          dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount
                        );

                        if (amount === 0) return;

                          const selectedId =
                            selectedWorkOrderType === "Existing Work Order"
                              ? selectedExistingWorkOrder
                              : projectId;

                        const res = await GetDateWiseData(
                           selectedId,
                          "DeductionSummary",
                          typeofData,
                          selectedWorkOrderType,
                        );

                        console.log("DeductionSummary Response:", res);

                        setBillSummaryData(res);
                        setCurrentPage(1);
                        setShowSpecific(7);
                      }}
                        className="dashboardCard deductionCard" style={{
                          cursor:
                            Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount) > 0
                              ? "pointer"
                              : "not-allowed",
                          opacity:
                            Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount) > 0
                              ? 1
                              : 0.6,
                        }}>
                        <div className="cardContent">
                          <div className="cardIcon">
                            <img src={TotalDeductionAmount64} alt="" />
                          </div>

                          <div className="cardDetails">
                            <h6>{t("Total Deduction Amount")}</h6>
                            <h5>
                              ₹{" "}
                              {(Number(
                                dateData?.TotalDeductionAmount ??
                                getData?.TotalDeductionAmount
                              ) || 0).toLocaleString("en-IN")}
                            </h5>
                          </div>
                          <div className="arrow-icon">
                          <img
                            src="/Arrow-Total-Original-Limit-Allocated.png"
                            alt=""
                          />
                        </div>
                        </div>     
                      </div>

                    </div>

                    <div className="dashboardChartSection" style={{
                      alignItems: "stretch"
                    }}>

                      {/* Left Side */}
                      <div className="dashboardLeft" style={{
                        display: "flex",
                        flexDirection: "column"
                      }}>

                        {/* Bar Chart */}
                        <div className="chartCard">

                          <div className="chartHeader">
                            <h3>{t("Categories")}</h3>

                            <div className="yearFilter">
                              <label>{t("Select Year")} :</label>

                              <select
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                              >
                                <option value="All">{t("All Years")}</option>
                                <option value="2026-2027">2026-2027</option>
                                <option value="2025-2026">2025-2026</option>
                                <option value="2024-2025">2024-2025</option>
                                <option value="2023-2024">2023-2024</option>
                                <option value="2022-2023">2022-2023</option>
                                <option value="2021-2022">2021-2022</option>
                                <option value="2020-2021">2020-2021</option>
                                <option value="2019-2020">2019-2020</option>
                                <option value="2018-2019">2018-2019</option>
                              </select>
                            </div>

                          </div>

                          {chartLoading ? (
                            <div className="chartLoader">
                              <div className="spinner" />
                            </div>
                          ) : (
                            <ReactApexChart
                              type="bar"
                              height={400}
                              series={barChartSeries}
                              options={barChartOptions}
                            />
                          )}
                        </div>

                      </div>

                      {/* Right Side */}

                      <div className="dashboardRight" style={{
                        display: "flex"
                      }}>

                        <div className="pieChartCard">

                          <h3>{t("Taxes And Amounts")}</h3><br></br>

                          {!deductionData?.length ? (

                            <ReactApexChart
                              options={state4.options}
                              series={state4.series}
                              type="donut"
                              height={400}
                            />

                          ) : (

                            <ReactApexChart
                              options={state5.options}
                              series={state5.series}
                              type="donut"
                              height={400}
                            />

                          )}

                        </div>

                      </div>

                    </div>

                    {/* Vendor Bills + Head Details */}
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "stretch",
                        marginTop: "20px",
                        flexWrap: "nowrap",
                      }}
                    >

                      {/* ================= Vendor Bills (65%) ================= */}
                      <div
                        style={{
                          flex: showHeadDetails ? "0 0 100%" : "1",
                          background: "#fff",
                          borderRadius: "18px",
                          padding: "20px",
                          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                          border: "1px solid #edf1f7",
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <h3 style={{ margin: 0 }}>{t("Vendor Bills")}</h3>
                        </div>

                        <div className="tableDesign" style={{ background: "#2C78DB" }}>
                          <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                              <tr style={{ color: "white", height: "3rem", fontSize: "18px" }}>
                               <th style={{ width: "20%" }}>{t("BILL NUMBER/PROJECT ID")}</th>
                                <th style={{ width: "15%" }}>{t("NAME")}</th>
                                <th style={{ width: "22%" }}>{t("TOTAL AMOUNT PAYABLE")}</th>
                                <th style={{ width: "22%" }}>{t("DEDUCTION")}</th>
                                <th style={{ width: "10%" }}>{t("STATUS")}</th>
                                <th style={{ width: "28%" }}>{t("DATE")}</th>
                                <th style={{ width: "9%" }}>{t("PROGRESS")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {currentTableData.length < 1 ? (
                                <tr>
                                  <td
                                    colSpan="7"
                                    style={{
                                      textAlign: "center",
                                      padding: "20px",
                                      background: "#f9f9f9",
                                      fontSize:"18px"
                                    }}
                                  >
                                    {t("No Bills Found")}
                                  </td>
                                </tr>
                              ) : (
                                currentTableData.map((bill, index) => {
                                  const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                                  let icon =
                                    bill.Status === "Sent to Bank"
                                      ? forth
                                      : bill.Status === "Successful/Paid"
                                        ? third
                                        : bill.Status === "false"
                                          ? Second
                                          : first;

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background: bgColor,
                                        fontSize: "18px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      <td>{bill.UniqueID}</td>

                                      <td>{bill.Vendor_Company_Name}</td>
                                      <td>
  {bill.TotalAmount != null && bill.TotalAmount !== ""
    ? `₹${Number(bill.TotalAmount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>

<td>
  {bill.DeductionAmount != null && bill.DeductionAmount !== ""
    ? `₹${Number(bill.DeductionAmount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>
                                      <td>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                          }}
                                        >
                                          {/* <img
                                            src={
                                              bill.Status === "Sent to Bank" ||
                                                bill.Status === "Successful/Paid"
                                                ? Approved32
                                                : Disable32
                                            }
                                            width={14}
                                            alt=""
                                          />
                                          {getApprovalStatus(bill)} */}{bill.Status}
                                        </div>
                                      </td>

                                      <td>
  {bill.UploadedOn
    ? new Date(bill.UploadedOn).toLocaleDateString("en-GB")
    : "-"}
</td>

                                      <td style={{ textAlign: "center" }}>
                                        <img src={icon} alt="" />
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "15px",
                          }}
                        >
                          <button
                            onClick={() =>
                              setCurrentPage((p) => Math.max(p - 1, 1))
                            }
                            disabled={totalPages === 0 || currentPage === 1}
                          >
                            {t("Previous")}
                          </button>

                          <span>
                            {t("Page")} {totalPages === 0 ? 0 : currentPage} {t("of")}{" "}
                            {totalPages}
                          </span>

                          <button
                            onClick={() =>
                              setCurrentPage((p) => Math.min(p + 1, totalPages))
                            }
                            disabled={currentPage === totalPages}
                          >
                            {t("Next")}
                          </button>
                        </div> */}
                      </div>

                      {/* ================= Head Details (35%) ================= */}

                      {/* {showHeadDetails && (
                        <div
                          style={{
                            flex: "0 0 35%",
                            background: "#fff",
                            borderRadius: "18px",
                            padding: "20px",
                            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                            border: "1px solid #edf1f7",
                            overflowY: "auto",
                            maxHeight: "430px",
                          }}
                        >
                          <h3 style={{ marginBottom: "15px" }}>
                            {t("Head Details")}
                          </h3>

                          <table className="table table-striped">
                            <thead className="table-primary">
                              <tr>
                                <th>{t("Sr.No")}</th>
                                <th>{t("Head ID")}</th>
                                <th>{t("Head Name")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {headFetchedData.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.HeadID}</td>
                                  <td>{item.HeadName}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                        </div>

                      )} */}

                    </div>


                    {/* ── Overlapping summary ── */}
                    {selectedWorkOrderType !== "Existing Work Order" && (
                      // Your complete District Wise Overlapping TS Summary Report
                      <div className="col-12 mb-3 mt-3" style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px" }}>
                        <h3 className='text-center fw-bold'>{t("District Wise Overlapping TS Summary Report")}</h3>
                        <div className='col-12 tableDesign' style={{ background: '#2C78DB',overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}>
                          <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                <th style={{ width: "10%" }}>{t("Scheme Name")}</th>
                                <th style={{ width: '10%' }}>{t("District Name")}</th>
                                <th style={{ width: '15%' }}>{t("Gram Panchayat Name")}</th>
                                <th style={{ width: '25%' }}>{t("Work Name")}</th>
                                <th style={{ width: '20%' }}>{t("TS Amount")}</th>
                                <th style={{ width: '20%' }}>{t("Overlapped MHUID")}</th>
                                <th style={{ width: '20%' }}>{t("Remark Of Overlapping")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {overlappingData?.length === 0 ? (
                                <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' , fontSize: "18px" }}>{t("No data available")}</td></tr>
                              ) : overlappingData?.map((head, index) => (
                                <tr key={index} style={{ backgroundColor: "#E5F4FB", fontSize: "18px", fontWeight: "500" }}>
                                  <td style={{ padding: '8px' }}>{head?.HeadCode}</td>
                                  <td style={{ padding: '8px' }}>{head?.District}</td>
                                  <td style={{ padding: '8px' }}>{head?.GramPanchayat}</td>
                                  <td style={{ padding: '8px' }}>{head?.WorkName}</td>
                                  <td style={{ padding: "8px" }}>
  {head?.TechnicalSanctionAmt != null &&
  head?.TechnicalSanctionAmt !== ""
    ? `₹${Number(head.TechnicalSanctionAmt).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>
                                  <td style={{ padding: '8px' }}>{head?.TechnicalSanctionNo}</td>
                                  <td style={{ padding: '8px' }}>{head?.remark}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}



                  </>
                ) : (
                  <h4 style={{ textAlign: 'center', marginTop: '20px' , fontSize:"18px"}}>{t("No data found")}</h4>
                )}
              </>
            )}
          </>
        )}

        {/* ── Detail views ── */}
        {tableData && showspecific === 1 && (
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12'>
                <div className="col-12"><button className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                  onClick={() => {
                    setSelectedDistrict("");
                    setSelectedTaluka("");
                    setSelectedHeadCode("");
                    setWorkCostSearch("");
                    setBillSummarySearch("");
                    setBillDetailsSearch("");
                    setDeductionSummarySearch("");
                    setCurrentPage(1);
                    setShowSpecific(0);
                  }}>
                  {t("Back")}</button>
                </div>
                <div className="col-11 my-0 mx-auto">
                  <div className="row">
                    <div className="col-12 py-2 d-flex justify-content-left align-items-center">
                      <h5 className="my-auto fw-bold d-flex align-items-center">
                        <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                        <span>
                          {selectedWorkOrderType === "Existing Work Order"
                            ? t("Total Work Cost for Work Name")
                            : `${t("Total Work Cost for MHUID")} - ${MHUID}`}
                        </span>
                      </h5>
                    </div>
                  </div>
                </div>
                {/* ================= WORK COST FILTERS ================= */}
<div
  className="col-11 mx-auto mb-3"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  }}
>
  {/* HeadCode Filter - Hidden for RoleID 24, 25, 40, 41 */}
  {![24, 25, 40, 41].includes(RoleID) && (
    <div style={{ padding: "4px 0" }}>
      <select
        value={selectedHeadCode}
        onChange={(e) => {
          setSelectedHeadCode(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          width: "170px",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f1f6fc",
          fontSize: "13px",
          height: "40px",
        }}
      >
        <option value="">Select HeadCode</option>

        {headCodeOptions.map((headCode, index) => (
          <option key={index} value={headCode}>
            {headCode}
          </option>
        ))}
      </select>
    </div>
  )}

  {/* District Filter */}
                  {[24, 25, 40, 41, 29].includes(RoleID) && (
                    <div style={{ padding: "4px 0" }}>
                      <select
                        value={selectedDistrict}
                        onChange={(e) => {
                          setSelectedDistrict(e.target.value);
                          setSelectedTaluka("");
                          setCurrentPage(1);
                        }}
                        style={{
                          width: "170px",
                          padding: "8px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "13px",
                          height: "40px",
                        }}
                      >
                        <option value="">Select District</option>
 
                        {districtOptions.map((district, index) => (
                          <option key={index} value={district}>
                            {district}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

  {/* Taluka Filter */}
  <div style={{ padding: "4px 0" }}>
    <select
      value={selectedTaluka}
      onChange={(e) => {
        setSelectedTaluka(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "170px",
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "13px",
        height: "40px",
      }}
    >
      <option value="">Select Taluka</option>

      {talukaOptions.map((taluka, index) => (
        <option key={index} value={taluka}>
          {taluka}
        </option>
      ))}
    </select>
  </div>

  {/* Random Search */}
  <div style={{ padding: "4px 0" }}>
    <input
      type="text"
      value={workCostSearch}
      onChange={(e) => {
        setWorkCostSearch(e.target.value);
        setCurrentPage(1);
      }}
      placeholder="Search Here..."
      style={{
        width: "170px",
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "13px",
        height: "40px",
      }}
    />
  </div>
</div>
                <div className="col-12 pb-5">
                  <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
                    <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto',overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative", }}>
                      <table className='m-0 py-0 ALlWorkCostData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                          <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                            <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Sr.No")}</th>
                            <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("District")}</th>
                            <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Taluka")}</th>
                            <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("HeadCode")}</th>
                            <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Work Name")}</th>
                            <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("MHUID")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" , fontSize: "18px"}}>{t("Work Amount (₹)")}</th>
                          </tr>
                        </thead>

                        <tbody>

                          {console.log("workCostData:", workCostData.length)}
                          {console.log("tableData:", tableData.length)}
                          {console.log("currentTableData:", currentTableData.length)}

                          {currentTableData?.length > 0 ? (
                            <>
                              {currentTableData.map((item, idx) => (
                                <tr
                                  key={idx}
                                  style={{
                                    backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                    fontSize: "18px",
                                    fontWeight: "400",
                                  }}
                                >
                                  <td style={{ fontSize: "18px"}}>{(currentPage - 1) * billsPerPage + idx + 1}</td>
                                  <td style={{ fontSize: "18px"}}>{item.talulka || item.District || "-"}</td>
                                  <td style={{ fontSize: "18px"}}>{item.Taluka || item.ulb}</td>
                                  <td style={{ fontSize: "18px"}}>{item.HeadCode}</td>
                                  <td style={{ fontSize: "18px"}}>{item.WorkName || item.Work_name}</td>


                                  {/* <td>
                                    {selectedWorkOrderType === "Existing Work Order"
                                      ? "-"
                                      : item.TechnicalUID || MHUID}
                                  </td> */}

                                  <td style={{ fontSize: "18px"}}>
                                    {selectedWorkOrderType === "Existing Work Order"
                                      ? "-"
                                      : ["NULL", "null", "", null, undefined].includes(item.TechnicalUID || MHUID)
                                        ? "-"
                                        : item.TechnicalUID || MHUID}
                                  </td>


                                  <td style={{ fontSize: "18px"}}>
                                    ₹{" "}
                                    {Number(
                                      item.ApprovedWorkAmount ||
                                      item.Proposal_amount ||
                                      0
                                    ).toLocaleString("en-IN")}
                                  </td>
                                </tr>
                              ))}

                              {/* Grand Total Row */}
                                       <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0",fontSize:"18px"  }}>
                                <td colSpan={6} style={{ fontSize: "18px" ,textAlign:"right"}}>{t("Page Total")}</td>
                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    pagetotalpaidamt1
                                  ).toLocaleString("en-IN")}
                                </td>
                              </tr>
                              <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                                <td colSpan={6} style={{ fontSize: "18px" ,textAlign:"right"}}>{t("Gross Total")}</td>
                                   <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                 totalpaidamt1                                  ).toLocaleString("en-IN")}
                                </td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td colSpan={6} className="fw-bold" style={{ fontSize: "18px"}}>
                                {t("No data found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "4rem",
                        alignItems: "center",
                      }}
                      className="mt-3"
                    >
                      <div>
                        <p className="text-gray-600" style={{ fontSize: "18px" }}>
                          {t("Showing")}{" "}
                          {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
                          {t("to")}{" "}
                          {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
                          {t("of")} {tableData.length} {t("entries")}
                        </p>
                      </div>

                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {limitAllotedData.length > 0 && showspecific === 2 && (
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12'>
                <div className="col-12"><button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button></div>
                <div className="col-11 my-0 mx-auto">
                  <h5 className="my-auto fw-bold d-flex align-items-center">
                    <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                    <span>{t("Total Limit Alloted for MHUID")} - {MHUID}</span>
                  </h5>
                </div>
                <div className="col-12 pb-5">
                  <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", overflowX: "hidden" }}>
                    <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto',     overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}>
                      <table className='m-0 py-0 ALlWorkCostData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead  style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                          <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Sr.No")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Taluka")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("HeadCode")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Work Name")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Physical Progress (%)")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Demand Requested (₹)")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Limit Allocated (₹)")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {limitAllotedData?.length > 0 ? (() => {
                            const totaltscount = limitAllotedData.reduce((s, v) => s + parseFloat(v.DemandAmount || 0), 0);
                            const totaltsamount = limitAllotedData.reduce((s, v) => s + parseFloat(v.OriginalLimitAllocatedAmount || 0), 0);
                            return (<>
                              {limitAllotedData.map((item, idx) => (
                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1", fontSize: "18px", fontWeight: "400" }}>
                                  <td>{idx + 1}</td><td>{item.Taluka}</td><td>{item.HeadCode}</td><td>{item.ProposalID}</td><td>{item.physicalValue}</td>
                                  <td>₹ {Number(item.DemandAmount).toLocaleString()}</td>
                                  <td>₹ {Number(item.OriginalLimitAllocatedAmount).toLocaleString()}</td>
                                </tr>
                              ))}
                              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                                <td colSpan={5}>{t("Grand Total")}</td>
                                <td>₹ {Number(totaltscount).toLocaleString()}</td>
                                <td>₹ {Number(totaltsamount).toLocaleString()}</td>
                              </tr>
                            </>);
                          })() : <tr><td colSpan={7} className='fw-bold'>{t("No data found")}</td></tr>}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {amountReleasedData.length > 0 && showspecific === 3 && (
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12'>
                <div className="col-12"><button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button></div>
                <div className="col-11 my-0 mx-auto">
                  <h5 className="my-auto fw-bold d-flex align-items-center">
                    <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
                    <span>{t("Total Amount Release for MHUID")} - {MHUID}</span>
                  </h5>
                </div>
                <div className="col-12 pb-5">
                  <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", overflowX: "hidden" }}>
                    <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto',overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative", }}>
                      <table className='m-0 py-0 ALlWorkCostData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                          <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Sr.No")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Taluka")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("HeadCode")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Work Name")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Physical Progress (%)")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Limit Allocated (₹)")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" }}>{t("Bill Generated Amount (₹)")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {amountReleasedData?.length > 0 ? (() => {
                            const totaltscount = amountReleasedData.reduce((s, v) => s + parseFloat(v.DemandAmount || 0), 0);
                            const totaltsamount = amountReleasedData.reduce((s, v) => s + parseFloat(v.ReleaseAmountTillDate || 0), 0);
                            return (<>
                              {amountReleasedData.map((item, idx) => (
                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1", fontSize: "12px", fontWeight: "400" }}>
                                  <td>{idx + 1}</td>
                                  <td>{item.Taluka }</td
                                  ><td>{item.HeadCode}</td>
                                  <td>{item.ProposalID}</td>
                                  <td>{item.physicalValue}</td>
                                  <td>₹ {Number(item.DemandAmount).toLocaleString()}</td>
                                  <td>₹ {Number(item.ReleaseAmountTillDate).toLocaleString()}</td>
                                </tr>
                              ))}
                              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                                <td colSpan={5}>{t("Grand Total")}</td>
                                <td>₹ {Number(totaltscount).toLocaleString()}</td>
                                <td>₹ {Number(totaltsamount).toLocaleString()}</td>
                              </tr>
                            </>);
                          })() : <tr><td colSpan={7} className='fw-bold'>{t("No data found")}</td></tr>}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {tableData && showspecific === 4 && (
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12'>
                <div className="col-12"><button className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                  onClick={() => {
                    setSelectedDistrict("");
                    setSelectedTaluka("");
                    setSelectedHeadCode("");
                    setWorkCostSearch("");
                    setBillSummarySearch("");
                    setBillDetailsSearch("");
                    setDeductionSummarySearch("");

                    setCurrentPage(1);
                    setShowSpecific(0);
                  }}>
                  {t("Back")}</button>
                  </div>
                <div className="col-11 my-0 mx-auto">
                  <h5 className="my-auto fw-bold d-flex align-items-center">
                    <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />

                    <span>
                      {selectedWorkOrderType === "Existing Work Order"
                        ? t("Total Work Order for Work Name")
                        : `${t("Total Work Order for MHUID")} - ${MHUID}`}
                    </span>
                  </h5>
                </div>
               {/* ================= WORK ORDER FILTERS ================= */}
<div
  className="col-11 mx-auto mb-3"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  }}
>
  {/* HeadCode Filter - Hidden for RoleID 24, 25, 40, 41 */}
  {![24, 25, 40, 41].includes(RoleID) && (
    <div style={{ padding: "4px 0" }}>
      <select
        value={selectedHeadCode}
        onChange={(e) => {
          setSelectedHeadCode(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          width: "170px",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f1f6fc",
          fontSize: "13px",
          height: "40px",
        }}
      >
        <option value="">Select HeadCode</option>

        {[...new Set(
          (Array.isArray(workCostData) ? workCostData : [])
            .map((item) => item.HeadCode)
            .filter(Boolean)
        )]
          .sort()
          .map((headCode, index) => (
            <option key={index} value={headCode}>
              {headCode}
            </option>
          ))}
      </select>
    </div>
  )}

  {/* Taluka Filter */}
  <div style={{ padding: "4px 0" }}>
    <select
      value={selectedTaluka}
      onChange={(e) => {
        setSelectedTaluka(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "170px",
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "13px",
        height: "40px",
      }}
    >
      <option value="">Select Taluka</option>

      {[...new Set(
        (Array.isArray(workCostData) ? workCostData : [])
          .map((item) => item.Taluka || item.ulb)
          .filter(Boolean)
      )]
        .sort()
        .map((taluka, index) => (
          <option key={index} value={taluka}>
            {taluka}
          </option>
        ))}
    </select>
  </div>

  {/* Random Search */}
  <div style={{ padding: "4px 0" }}>
    <input
      type="text"
      value={workCostSearch}
      onChange={(e) => {
        setWorkCostSearch(e.target.value);
        setCurrentPage(1);
      }}
      placeholder="Search Here..."
      style={{
        width: "170px",
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "13px",
        height: "40px",
      }}
    />
  </div>
</div>
                <div className="col-12 pb-5">
                  <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", overflowX: "hidden" }}>
                    <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB' ,overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative", }}>
                      <table className='m-0 py-0 ALlWorkCostData' style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                          <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                            <th style={{ minWidth: "250px", padding: "8px" , fontSize: "18px" }}>{t("Sr.No")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" , fontSize: "18px" }}>{t("Taluka")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" , fontSize: "18px"  }}>{t("HeadCode")}</th>
                            <th style={{ minWidth: "250px", padding: "8px"  , fontSize: "18px" }}>{t("Work Name")}</th>
                            <th style={{ minWidth: "250px", padding: "8px" , fontSize: "18px" }}>{t("MHUID")}</th>
                            <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px"  }}>{t("Work Order Amount (₹)")}</th>
                          </tr>
                        </thead >
                        <tbody>
                          {tableData?.length > 0 ? (() => {
                            const totaltsamount = (Array.isArray(workOrdersData) ? workOrdersData : []).reduce((s, v) => s + parseFloat(v.ApprovedWorkAmount || 0), 0);
                            return (<>
                              {currentTableData.map((item, idx) => (
                                <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1", fontSize: "18px", fontWeight: "400" }}>
                                  <td style={{ fontSize: "18px"}}>{(currentPage - 1) * billsPerPage + idx + 1}</td>
                                  <td style={{ fontSize: "18px"}}>{item.Taluka ?? item.ulb ?? "-"}</td>
                                  <td style={{ fontSize: "18px"}}>{item.HeadCode}</td>
                                  <td style={{ fontSize: "18px"}}>{item.WorkName}</td>
                                  <td style={{ fontSize: "18px"}}>
                                    {["NULL", "null", "", null, undefined].includes(item.TechnicalUID)
                                      ? "-"
                                      : item.TechnicalUID}
                                  </td>
                                  <td style={{ fontSize: "18px"}}>₹ {Number(item.ApprovedWorkAmount).toLocaleString("en-IN")}</td>
                                </tr>
                              ))}
                              {/* Grand Total Row */}
                             <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,fontSize:"18px" }}>
                                <td style={{ fontSize: "18px" ,textAlign:"right"}} colSpan={5}>{t("Page Total")}</td>
                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                   pagetotalpaidamt1
                                  ).toLocaleString("en-IN")}
                                </td>
                              </tr>
                              {/* Grand Total Row */}
                              <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0",fontSize:"18px" }}>
                                <td style={{ fontSize: "18px" ,textAlign:"right"}} colSpan={5}>{t("Gross Total")}</td>
                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                totalpaidamt1
                                  ).toLocaleString("en-IN")}
                                </td>
                              </tr>
                            </>);
                          })() : <tr><td colSpan={6} className='fw-bold' style={{ fontSize: "18px"}}>{t("No data found")}</td></tr>}
                        </tbody>
                      </table>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "4rem",
                        alignItems: "center",
                      }}
                      className="mt-3"
                    >
                      <div>
                        <p className="text-gray-600" style={{ fontSize: "18px" }}>
                          {t("Showing")}{" "}
                          {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
                          {t("to")}{" "}
                          {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
                          {t("of")} {tableData.length} {t("entries")}
                        </p>
                      </div>

                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {currentTableData && showspecific === 5 && (
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12'>

                <div className="col-12">
                  <button
                    className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                    onClick={() => {
                      setSelectedDistrict("");
                      setSelectedTaluka("");
                      setSelectedHeadCode("");
                      setWorkCostSearch("");
                      setBillSummarySearch("");
                      setBillDetailsSearch("");
                      setDeductionSummarySearch("");

                      setCurrentPage(1);
                      setShowSpecific(0);
                    }}
                  >
                    {t("Back")}
                  </button>
                </div>

                <div className="col-11 my-0 mx-auto">
                  <div className="row">
                    <div className="col-12 py-2 d-flex justify-content-left align-items-center">
                      <h5 className="my-auto fw-bold d-flex align-items-center">
                        <img
                          src={TotalBillAmount64}
                          alt=""
                          style={{ width: "24px", height: "24px" }}
                          className="me-2"
                        />
                        <span>{t("Total Bill Amount")}</span>
                      </h5>
                    </div>
                  </div>
                </div>

                {/* ================= BILL SUMMARY FILTERS ================= */}
<div
  className="col-11 mx-auto mb-3"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  }}
>

  {/* District Filter - Only for RoleID 40,41,24,25,29 */}
  {[40, 41, 24, 25, 29].includes(RoleID) && (
    <div style={{ padding: "4px 0" }}>
      <select
        value={selectedDistrict}
        onChange={(e) => {
          setSelectedDistrict(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          width: "170px",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f1f6fc",
          fontSize: "13px",
          height: "40px",
        }}
      >
        <option value="">Select District</option>

        {[...new Set(
  (billSummaryData || [])
    .map((item) => item.District?.split("-")[0]?.trim())
    .filter(Boolean)
)]
  .sort()
  .map((district, index) => (
<option key={index} value={district}>
      {district}
</option>
  ))}
      </select>
    </div>
  )}

  {/* Taluka Filter - For Other Roles */}
  {![40, 41, 24, 25, 29].includes(RoleID) && (
    <div style={{ padding: "4px 0" }}>
      <select
        value={selectedTaluka}
        onChange={(e) => {
          setSelectedTaluka(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          width: "170px",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f1f6fc",
          fontSize: "13px",
          height: "40px",
        }}
      >
        <option value="">Select Taluka</option>

        {[...new Set(
          (billSummaryData || [])
            .map((item) => item.Taluka || item.ulb)
            .filter(Boolean)
        )]
          .sort()
          .map((taluka, index) => (
            <option key={index} value={taluka}>
              {taluka}
            </option>
          ))}
      </select>
    </div>
  )}

  {/* Random Search */}
  <div style={{ padding: "4px 0" }}>
    <input
      type="text"
      value={billSummarySearch}
      onChange={(e) => {
        setBillSummarySearch(e.target.value);
        setCurrentPage(1);
      }}
      placeholder="Search Here..."
      style={{
        width: "170px",
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "13px",
        height: "40px",
      }}
    />
  </div>

</div>

                <div className="col-12 pb-5">
                  <div
                    className='m-auto mb-3'
                    style={{
                      backgroundColor: "white",
                      padding: "40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px"
                    }}
                  >
                    <div
                      className='col-12 tableDesign DistrictTableContianerModel2'
                      style={{ background: '#2C78DB', overflowX: 'auto' , overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative",}}
                    >
                      <table className='m-0 py-0 ALlWorkCostData' style={{ width: "100%" }}>
                        <thead style={{ position: "sticky",  backgroundColor: "#2C78DB",
                      top: 0,
                      zIndex: 10}}>
                          <tr style={{ color: "white", height: "3rem", fontSize: "18px" }}>
                            <th style={{ fontSize: "18px"}}>{t("Sr.No")}</th>
                            <th style={{ fontSize: "18px"}}>
                              {RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
                                ? t("District")
                                : t("Taluka")}
                            </th>
                            <th style={{ fontSize: "18px"}}>{t("Total Bill Amount")}</th>
                            <th style={{ fontSize: "18px"}}>{t("Action")}</th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentTableData.length > 0 ? (
                            <>
                              {currentTableData.map((item, idx) => (
                                <tr
                                  key={idx}
                                  style={{
                                    backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                    fontSize: "12px",
                                  }}
                                >
                                  <td style={{ fontSize: "18px"}}>{(currentPage - 1) * billsPerPage + idx + 1}</td>

                                  <td style={{ fontSize: "18px"}}>
                                    {RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
                                      ? item.District
                                      : item.Taluka || item.ulb}
                                  </td>

                                  <td style={{ fontSize: "18px"}}>
                                    ₹ {Number(item.TotalBillAmount).toLocaleString("en-IN")}
                                  </td>

                                  <td style={{ fontSize: "18px"}}>
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={async () => {
                                        const location =
                                          RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
                                            ? item.District
                                            : item.Taluka || item.ulb;

                                        const selectedId =
                                          selectedWorkOrderType === "Existing Work Order"
                                            ? selectedExistingWorkOrder
                                            : projectId;
 
                                        const res = await GetDateWiseData(
                                          selectedId,          // same as KPI card
                                          "BillDetails",
                                          typeofData,
                                          selectedWorkOrderType,
                                          location             // we'll use this in backend
                                        );
                                        setSelectedTaluka("");
                                        setBillDetailsSearch("");
                                        setBillDetailsData(res);
                                        setPreviousPage(5);
                                        setCurrentPage(1);
                                        setShowSpecific(6);
                                      }}
                                    >
                                      View
                                    </button>
                                  </td>
                                </tr>
                              ))}

                              {/* Grand Total */}
                             <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0",fontSize:"18px"  }}>
                                <td style={{ fontSize: "18px" ,textAlign:"right"}} colSpan={2}>{t("Page Total")}</td>
                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                  pagetotalpaidamt2
                                  ).toLocaleString("en-IN")}
                                </td>
                                <td></td>
                              </tr>
                              {/* Grand Total */}
                              <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0"  }}>
                                <td style={{ fontSize: "18px",textAlign:"right"}} colSpan={2} >{t("Gross Total")}</td>
                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                   
totalpaidamt2                                  ).toLocaleString("en-IN")}
                                </td>
                                <td></td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td style={{ fontSize: "18px"}} colSpan={4}>{t("No data found")}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "4rem",
                        alignItems: "center",
                      }}
                      className="mt-3"
                    >
                      <div>
                        <p className="text-gray-600" style={{ fontSize: "18px" }}>
                          {t("Showing")}{" "}
                          {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
                          {t("to")}{" "}
                          {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
                          {t("of")} {tableData.length} {t("entries")}
                        </p>
                      </div>

                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        )}

        {currentTableData && showspecific === 6 && (
          <div
            className="col-12"
            style={{
              backgroundColor: "#EFF3F8",
              height: "90vh",
              overflowX: "hidden",
              overflowY: "scroll",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12">

                <div className="col-12">
                  <button
                    className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
                    onClick={() => {
                      setSelectedTaluka("");
                      setBillDetailsSearch("");
                      setCurrentPage(1);
                      setShowSpecific(previousPage);
                    }}
                  >
                    {t("Back")}
                  </button>
                </div>

                <div className="col-11 my-0 mx-auto">
                  <div className="row">
                    <div className="col-12 py-2 d-flex justify-content-left align-items-center">
                      <h5 className="my-auto fw-bold d-flex align-items-center">
                        <img
                          src={TotalBillAmount64}
                          alt=""
                          style={{ width: "24px", height: "24px" }}
                          className="me-2"
                        />
                        <span>{t("Bill Details")}</span>
                      </h5>
                    </div>
                  </div>
                </div>
                {/* ================= BILL DETAILS FILTERS ================= */}
<div
  className="col-11 mx-auto mb-3"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  }}
>

  {/* Taluka Filter */}
  <div style={{ padding: "4px 0" }}>
    <select
      value={selectedTaluka}
      onChange={(e) => {
        setSelectedTaluka(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "170px",
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "13px",
        height: "40px",
      }}
    >
      <option value="">Select Taluka</option>

      {[...new Set(
        (billDetailsData || [])
          .map((item) => item.ulb)
          .filter(Boolean)
      )]
        .sort()
        .map((taluka, index) => (
          <option key={index} value={taluka}>
            {taluka}
          </option>
        ))}
    </select>
  </div>

  {/* Random Search */}
  <div style={{ padding: "4px 0" }}>
    <input
      type="text"
      value={billDetailsSearch}
      onChange={(e) => {
        setBillDetailsSearch(e.target.value);
        setCurrentPage(1);
      }}
      placeholder="Search Here..."
      style={{
        width: "170px",
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "13px",
        height: "40px",
      }}
    />
  </div>

</div>

                <div className="col-12 pb-5">
                  <div
                    className="m-auto mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                    }}
                  >
                    <div
                      className="col-12 tableDesign DistrictTableContianerModel2"
                      style={{ background: "#2C78DB", overflowX: "auto" ,overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative"}}
                    >
                      <table
                        className="m-0 py-0 ALlWorkCostData"
                        style={{ width: "100%" }}
                      >
                        <thead  style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                          <tr
                            style={{
                              color: "white",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th style={{ fontSize: "18px"}}>Sr.No</th>
                            <th style={{ fontSize: "18px"}}>Demand ID</th>
                            <th style={{ fontSize: "18px"}}>Bill Number</th>
                            <th style={{ fontSize: "18px"}}>Work Name</th>
                            <th style={{ fontSize: "18px"}}>District</th>
                            <th style={{ fontSize: "18px"}}>Taluka</th>
                            <th style={{ fontSize: "18px"}}>Vendor Name</th>
                            <th style={{ fontSize: "18px"}}>Bill Amount</th>
                            <th style={{ fontSize: "18px"}}>Net Payable</th>
                            <th style={{ fontSize: "18px"}}>Deduction</th>
                            <th style={{ fontSize: "18px"}}>Date</th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentTableData.length > 0 ? (
                            <>
                              {currentTableData.map((item, idx) => (
                                <tr
                                  key={idx}
                                  style={{
                                    backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                    fontSize: "18px",
                                  }}
                                >
                                  <td style={{ fontSize: "18px"}}>{(currentPage - 1) * billsPerPage + idx + 1}</td>
                                  <td style={{ fontSize: "18px"}}>{item.DemandGenerationID}</td>
                                  <td style={{ fontSize: "18px"}}>{item.RABillNumber}</td>
                                  <td style={{ fontSize: "18px"}}>{item.ProjectName}</td>
                                  <td style={{ fontSize: "18px"}}>{item.District}</td>
                                  <td style={{ fontSize: "18px"}}>{item.ulb}</td>
                                  <td style={{ fontSize: "18px"}}>{item.ContractorName}</td>
                                  <td style={{ fontSize: "18px"}}>₹ {Number(item.BillAmount).toLocaleString("en-IN")}</td>
                                  <td style={{ fontSize: "18px"}}>₹ {Number(item.NetPayableAmount).toLocaleString("en-IN")}</td>
                                  <td style={{ fontSize: "18px"}}>₹ {Number(item.DeductionAmount).toLocaleString("en-IN")}</td>
                                  <td style={{ fontSize: "18px"}}>{formatDate(item.Date) || item.Date}</td>
                                </tr>
                              ))}

                              {/* Grand Total */}
                                 <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                                <td colSpan={7} style={{ fontSize: "18px" ,textAlign:"right"}}>{t("Page Total")}</td>

                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    currentTableData.reduce(
                                      (sum, item) => sum + Number(item.BillAmount || 0),
                                      0
                                    )
                                  ).toLocaleString("en-IN")}
                                </td>

                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    currentTableData.reduce(
                                      (sum, item) => sum + Number(item.NetPayableAmount || 0),
                                      0
                                    )
                                  ).toLocaleString("en-IN")}
                                </td>

                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    currentTableData.reduce(
                                      (sum, item) => sum + Number(item.DeductionAmount || 0),
                                      0
                                    )
                                  ).toLocaleString("en-IN")}
                                </td>

                                <td></td>
                              </tr>
                              <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                                <td colSpan={7} style={{ fontSize: "18px", textAlign:"right"}}>{t("Gross Total")}</td>

                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    billDetailsData.reduce(
                                      (sum, item) => sum + Number(item.BillAmount || 0),
                                      0
                                    )
                                  ).toLocaleString("en-IN")}
                                </td>

                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    billDetailsData.reduce(
                                      (sum, item) => sum + Number(item.NetPayableAmount || 0),
                                      0
                                    )
                                  ).toLocaleString("en-IN")}
                                </td>

                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    billDetailsData.reduce(
                                      (sum, item) => sum + Number(item.DeductionAmount || 0),
                                      0
                                    )
                                  ).toLocaleString("en-IN")}
                                </td>

                                <td></td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td colSpan={11}>No data found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "4rem",
                        alignItems: "center",
                      }}
                      className="mt-3"
                    >
                      <div>
                        <p className="text-gray-600" style={{ fontSize: "18px" }}>
                          {t("Showing")}{" "}
                          {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
                          {t("to")}{" "}
                          {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
                          {t("of")} {tableData.length} {t("entries")}
                        </p>
                      </div>

                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        )}

        {currentTableData && showspecific === 7 && (
          <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
            <div className="col-11 m-auto">
              <div className='col-12'>

                <div className="col-12">
                  <button
                    className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
                    onClick={() => {
                      setSelectedDistrict("");
                      setSelectedTaluka("");
                      setSelectedHeadCode("");
                      setWorkCostSearch("");
                      setBillSummarySearch("");
                      setBillDetailsSearch("");
                      setDeductionSummarySearch("");

                      setCurrentPage(1);
                      setShowSpecific(0);
                    }}
                  >
                    {t("Back")}
                  </button>
                </div>

                <div className="col-11 my-0 mx-auto">
                  <div className="row">
                    <div className="col-12 py-2 d-flex justify-content-left align-items-center">
                      <h5 className="my-auto fw-bold d-flex align-items-center">
                        <img
                          src={TotalBillAmount64}
                          alt=""
                          style={{ width: "24px", height: "24px" }}
                          className="me-2"
                        />
                        <span>{t("Total Deduction Amount")}</span>
                      </h5>
                    </div>
                  </div>
                </div>

                {/* ================= DEDUCTION SUMMARY FILTERS ================= */}
<div
  className="col-11 mx-auto mb-3"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  }}
>

  {/* District Filter - RoleID 40,41,24,25,29 */}
  {[40, 41, 24, 25, 29].includes(RoleID) && (
    <div style={{ padding: "4px 0" }}>
      <select
        value={selectedDistrict}
        onChange={(e) => {
          setSelectedDistrict(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          width: "170px",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f1f6fc",
          fontSize: "13px",
          height: "40px",
        }}
      >
        <option value="">Select District</option>

        {[...new Set(
  (billSummaryData || [])
    .map((item) => item.District?.split("-")[0]?.trim())
    .filter(Boolean)
)]
  .sort()
  .map((district, index) => (
<option key={index} value={district}>
      {district}
</option>
  ))}
      </select>
    </div>
  )}

  {/* Taluka Filter - Other Roles */}
  {![40, 41, 24, 25, 29].includes(RoleID) && (
    <div style={{ padding: "4px 0" }}>
      <select
        value={selectedTaluka}
        onChange={(e) => {
          setSelectedTaluka(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          width: "170px",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f1f6fc",
          fontSize: "13px",
          height: "40px",
        }}
      >
        <option value="">Select Taluka</option>

        {[...new Set(
          (billSummaryData || [])
            .map((item) => item.Taluka || item.ulb)
            .filter(Boolean)
        )]
          .sort()
          .map((taluka, index) => (
            <option key={index} value={taluka}>
              {taluka}
            </option>
          ))}
      </select>
    </div>
  )}

  {/* Random Search */}
  <div style={{ padding: "4px 0" }}>
    <input
      type="text"
      value={deductionSummarySearch}
      onChange={(e) => {
        setDeductionSummarySearch(e.target.value);
        setCurrentPage(1);
      }}
      placeholder="Search Here..."
      style={{
        width: "170px",
        padding: "8px 12px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f1f6fc",
        fontSize: "13px",
        height: "40px",
      }}
    />
  </div>

</div>

                <div className="col-12 pb-5">
                  <div
                    className='m-auto mb-3'
                    style={{
                      backgroundColor: "white",
                      padding: "40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px"
                    }}
                  >
                    <div
                      className='col-12 tableDesign DistrictTableContianerModel2'
                      style={{ background: '#2C78DB', overflowX: 'auto' ,overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}
                    >
                      <table className='m-0 py-0 ALlWorkCostData' style={{ width: "100%" }}>
                        <thead  style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                          <tr style={{ color: "white", height: "3rem", fontSize: "18px" }}>
                            <th style={{ fontSize: "18px"}}>{t("Sr.No")}</th>
                            <th style={{ fontSize: "18px"}}>
                              {RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
                                ? t("District")
                                : t("Taluka")}
                            </th>
                            <th style={{ fontSize: "18px"}}>{t("Total Deduction Amount")}</th>
                            <th style={{ fontSize: "18px"}}>{t("Action")}</th>
                          </tr>
                        </thead>

                        <tbody>
                          {currentTableData.length > 0 ? (
                            <>
                              {currentTableData.map((item, idx) => (
                                <tr
                                  key={idx}
                                  style={{
                                    backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                    fontSize: "12px",
                                  }}
                                >
                                  <td style={{ fontSize: "18px"}}>{(currentPage - 1) * billsPerPage + idx + 1}</td>

                                  <td style={{ fontSize: "18px"}}>
                                    {RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
                                      ? item.District
                                      : item.Taluka || item.ulb}
                                  </td>

                                  <td style={{ fontSize: "18px"}}>
                                    ₹ {Number(item.TotalDeductionAmount).toLocaleString("en-IN")}
                                  </td>

                                  <td style={{ fontSize: "18px"}}>
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={async () => {
                                        const location =
                                          RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
                                            ? item.District
                                            : item.Taluka || item.ulb;

                                        const selectedId =
                                          selectedWorkOrderType === "Existing Work Order"
                                            ? selectedExistingWorkOrder
                                            : projectId;

                                            console.log("selected id ::",selectedId);
                                            


                                        const res = await GetDateWiseData(
                                          selectedId,
                                          "BillDetails",
                                          typeofData,
                                          selectedWorkOrderType,
                                          location
                                        );
                                        setSelectedTaluka("");
                                        setBillDetailsSearch("");
                                        setSelectedLocation(location);
                                        setBillDetailsData(res);
                                        setPreviousPage(7);
                                        setCurrentPage(1);
                                        setShowSpecific(6);
                                      }}
                                    >
                                      View
                                    </button>
                                  </td>
                                </tr>
                              ))}

                              {/* Grand Total */}
                               <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                                <td colSpan={2} style={{ fontSize: "18px",textAlign:"right"}}>{t("Page Total")}</td>
                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    currentTableData.reduce(
                                      (sum, item) => sum + Number(item.TotalDeductionAmount || 0),
                                      0
                                    )
                                  ).toLocaleString("en-IN")}
                                </td>
                                <td></td>
                              </tr>
                                <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                                <td colSpan={2} style={{ fontSize: "18px" ,textAlign:"right"}}>{t("Gross Total")}</td>
                                <td style={{ fontSize: "18px"}}>
                                  ₹{" "}
                                  {Number(
                                    billSummaryData.reduce(
                                      (sum, item) => sum + Number(item.TotalDeductionAmount || 0),
                                      0
                                    )
                                  ).toLocaleString("en-IN")}
                                </td>
                                <td></td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td colSpan={4}>{t("No data found")}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "4rem",
                        alignItems: "center",
                      }}
                      className="mt-3"
                    >
                      <div>
                        <p className="text-gray-600" style={{ fontSize: "18px" }}>
                          {t("Showing")}{" "}
                          {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
                          {t("to")}{" "}
                          {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
                          {t("of")} {tableData.length} {t("entries")}
                        </p>
                      </div>

                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        )}



      </div>
    </>
  );
};

export default Dashboard;


//--> old code
// import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react'
// import AdminContext from '../../admin/StateContext/Application'
// import ReactApexChart from 'react-apexcharts';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import "./page.css";
// import { Approved32, Click32, Disable32, Earnings, Earningss, Earningsss, Error32, fifth, first, forth, Graph64, MoreMenu64, NewTasks64, Sales, Second, Spendthismonth64, third, TotalProjects64, Unclick32, YourBalance, ECSFile, TotalProjectCost, TotalProjectCost11, TotalLimitAlloted123, TotalWorkOrders, TotalAmountRelease, TotalBillAmount64, TotalDeductionAmount64, Edit32, Delete32 } from '../../../public/LoginImages/importimages';
// import '../../Users/pages/innercss.css'
// import { useLanguage } from '../../../lang/langcontext/LanguageContext';
// import autoTable from "jspdf-autotable";
// import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import "./ProjectDashboard.css"
// import GooglePagination from '../styles/GooglePagination';

// // ── Debounce hook ─────────────────────────────────────────────────────────────
// function useDebounce(value, delay) {
//   const [debouncedValue, setDebouncedValue] = useState(value);
//   useEffect(() => {
//     const handler = setTimeout(() => setDebouncedValue(value), delay);
//     return () => clearTimeout(handler);
//   }, [value, delay]);
//   return debouncedValue;
// }

// const Dashboard = () => {
//   const { language, toggleLanguage, t } = useLanguage();
//   const content = useContext(AdminContext);
//   const { GetTaxAmounts, GetVendorBills, getTaxAmountsByDate, GetDateWiseData, GetProjectInfo, GetOverLappingData, GetTotalTableData } = content;

//   // ── Core state ────────────────────────────────────────────────────────────
//   const [getData, SetData] = useState({});
//   const [vendorbills, setVendorBills] = useState([]);
//   const [loading, setloading] = useState(false);
//   const [dateData, setDateData] = useState([]);
//   const [projectdata, setProjectData] = useState([]);
//   const [projectId, setProjectId] = useState('');

//   const [MHUID, setMHUID] = useState('');
//   const [workCostData, setWorkCostData] = useState([]);
//   const [limitAllotedData, setLimitAllotedData] = useState([]);
//   const [amountReleasedData, setAmountReleasedData] = useState([]);
//   const [workOrdersData, setWorkOrdersData] = useState([]);

//   const [headFetchedData, setHeadFetchedData] = useState([]);
//   const [deductionData, setDeductionData] = useState([]);
//   const [newData, setnewData] = useState([]);
//   // console.log("newdata..........",newData);

//   const [overlappingData, setOverlappingData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const debouncedSearch = useDebounce(searchTerm, 300);

//   const [selectedYear, setSelectedYear] = useState("All");
//   const [proposalCount, setProposalCount] = useState(0);
//   const [technicalCount, setTechnicalCount] = useState(0);
//   const [workorderCount, setWorkorderCount] = useState(0);
//   const [billCount, setBillCount] = useState(0);
//   const [chartLoading, setChartLoading] = useState(false);

//   const [showspecific, setShowSpecific] = useState(0);
//   const [showWorkCostTable, setShowWorkCostTable] = useState(false);
//   const [showLimitAllotedTable, setShowLimitAllotedTable] = useState(false);
//   const [showAmountReleasedTable, setShowAmountReleasedTable] = useState(false);
//   const [showWorkOrdersTable, setShowWorkOrdersTable] = useState(false);
//   const [exportingPDF, setExportingPDF] = useState(false);
//   const [showGraph, setShowGraph] = useState("Table");

//   const [UserRole, setUserRole] = useState("");
//   const [typeofData, settypeofData] = useState("Select Head Code");
//   const [RoleID, setroleID] = useState(null);

//   const { GetProposallist, WorkOutwards, TechnicalOutwards, Usermenu } = content;

//   const [baseData, setBaseData] = useState([]);
//   const [showList, setShowList] = useState(false);
//   const [filteredData, setFilteredData] = useState([]);

//   const isAutoSettingHeadcode = useRef(false);
//   const projectIdRef = useRef(projectId);
//   projectIdRef.current = projectId;

//   // Track if initial load has run
//   const initialLoadDone = useRef(false);


//   const [selectedWorkOrderType, setSelectedWorkOrderType] = useState("");
//   const [existingData, setExistingData] = useState([]);
//   const [selectedExistingWorkOrder, setSelectedExistingWorkOrder] = useState("");
//   const [proposalUID, setProposalUID] = useState("");

//   const [showBillSummary, setShowBillSummary] = useState(false);
//   const [billSummaryData, setBillSummaryData] = useState([]);
//   const [loadingBillSummary, setLoadingBillSummary] = useState(false);
//   const [billDetailsData, setBillDetailsData] = useState([]);
//   const [selectedLocation, setSelectedLocation] = useState("");
//   const [previousPage, setPreviousPage] = useState(5);



//   // ── Pagination ────────────────────────────────────────────────────────────
//   const [currentPage, setCurrentPage] = useState(1);
//   const billsPerPage = 10;
//   const tableData = useMemo(() => {
//     console.log("showspecific:", showspecific);

//     switch (showspecific) {
//       case 1:
//         console.log("Using workCostData", workCostData);
//         return workCostData || [];

//       case 4:
//         console.log("Using workOrdersData", workOrdersData);
//         return workOrdersData || [];

//       case 5:
//         return billSummaryData || [];

//       case 6:
//         return billDetailsData || [];

//       case 7:
//         return billSummaryData || [];

//       default:
//         return vendorbills || [];
//     }
//   }, [
//     showspecific,
//     vendorbills,
//     workCostData,
//     workOrdersData,
//     billSummaryData,
//     billDetailsData,
//   ]);

//   const totalPages = useMemo(
//     () => Math.ceil(tableData.length / billsPerPage),
//     [tableData]
//   );

//   const currentTableData = useMemo(() => {
//     const start = (currentPage - 1) * billsPerPage;
//     return tableData.slice(start, start + billsPerPage);
//   }, [tableData, currentPage]);

//   // ── Helpers ───────────────────────────────────────────────────────────────
//   const isElementVisible = (element) => {
//     if (!element) return false;
//     const style = window.getComputedStyle(element);
//     return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
//   };

//   const normalizeText = (text) =>
//     text?.toString().normalize("NFC").replace(/\s+/g, " ").trim().toLowerCase();

//   const formatINR = useCallback((amount) => {
//     amount = Number(amount);
//     if (isNaN(amount)) return "0";
//     if (amount >= 10000000) return (amount / 10000000).toFixed(2) + " Cr";
//     if (amount >= 100000) return (amount / 100000).toFixed(2) + " Lakh";
//     return amount.toLocaleString("en-IN");
//   }, []);

//   const getApprovalStatus = useCallback((bill) => {
//     if (bill.Approvance1 === "false") return "Department Auditor Approval Pending";
//     if (bill.Approvance2 === "false") return "Department HOD(EE) Approval Pending";
//     if (bill.Approvance3 === "false") return "FD Auditor Approval Pending";
//     if (bill.Approvance4 === "false") return "FD AAO Approval Pending";
//     if (bill.Approvance5 === "false") return "FD AO Approval Pending";
//     if (bill.Approvance6 === "false") return "Deputy CAFO Approval Pending";
//     if (bill.Approvance7 === "false") return "CAFO Approval Pending";
//     return bill.Status;
//   }, []);

//   // ── Initial load: menu + proposals + tax amounts (parallel) ──────────────
//   useEffect(() => {
//     if (initialLoadDone.current) return;
//     initialLoadDone.current = true;

//     const init = async () => {
//       try {
//         // Run menu fetch and proposal fetch in parallel
//         const [menuData, proposalData] = await Promise.all([
//           Usermenu(),
//           GetProjectInfo('null', "GetALLProposal"),

//         ]);

//         // Process menu
//         if (menuData && typeof menuData === "object") {
//           const roleID = menuData?.Data?.RoleID;
//           setroleID(roleID);

//           // Fetch tax amounts based on role
//           if (roleID === 40 || roleID === 41 || roleID === 24 || roleID === 25 || RoleID === 29) {
//             GetAmountOfTaxes("State");
//           }
//         }

//         // Process proposals
//         if (proposalData) {
//           setnewData(proposalData);
//         }



//       } catch (err) {
//         console.error("Init error:", err);
//       }
//     };

//     init();
//   }, []); // eslint-disable-line


//   useEffect(() => {
//     const fetchExistingWorkOrders = async () => {
//       if (!typeofData) return;

//       const data = await GetProjectInfo(
//         "",
//         "ExistingWorkOrders",
//         typeofData
//       );

//       setExistingData(data || []);
//       console.log("ExistingWorkOrders API:", data);
//     };

//     fetchExistingWorkOrders();
//   }, [typeofData]);

//   // // Overall Dashboard Data (Initial Load)
//   // useEffect(() => {
//   //   const loadOverallDashboard = async () => {
//   //     try {
//   //       const overallData = await GetDateWiseData("", "DashboardOverall", typeofData);
//   //       setDateData(overallData || {});
//   //     } catch (err) {
//   //       console.error(err);
//   //     }
//   //   };

//   //   loadOverallDashboard();
//   // }, []);

//   // ── Chart data: only re-fetch when selectedYear changes ──────────────────
//   useEffect(() => {
//     fetchChartData();
//   }, [selectedYear, selectedWorkOrderType, selectedExistingWorkOrder,projectId,typeofData]); // eslint-disable-line

//   const fetchChartData = async () => {
//     try {
//       setChartLoading(true);
//       // Run all 4 in parallel




//       const [proposaldata, techincalData, workOrderData, billData, physicalProgressData] = await Promise.all([
//         GetProposallist("ProposalChart", typeofData, projectId),
//         TechnicalOutwards("TechnicalDashboard","", typeofData,projectId), 
//         WorkOutwards(selectedWorkOrderType || "" , typeofData,"WorkOrderChart",projectId),
//         TechnicalOutwards("BillChart",selectedWorkOrderType === "Overall" ? "" : selectedWorkOrderType, typeofData,projectId),
//         TechnicalOutwards("PhysicalProgressChart", selectedWorkOrderType, typeofData,projectId)
//       ]);


//       const filteredProposals = (proposaldata?.message || proposaldata || []).filter(
//         (item) => projectId || selectedYear === "All" || item.Proposal_year === selectedYear
//       );
//       const filteredTechnical = (techincalData?.message || techincalData || []).filter(
//         (item) => projectId || selectedYear === "All" || item.SanctionYear === selectedYear
//       );
//       const filteredWorkorder = (workOrderData?.message || workOrderData || []).filter(
//         (item) =>  projectId || selectedYear === "All" || item.ProposalYear === selectedYear
//       );
//       const filteredBills = (billData?.message || billData || []).filter(
//         (item) => projectId || selectedYear === "All" || item.ProposalYear === selectedYear
//       );

//       const filteredPhysicalProgress =
//         (physicalProgressData?.message || physicalProgressData || []).filter(
//           (item) => projectId || selectedYear === "All" || item.ProposalYear === selectedYear
//         );
//       console.log("physicalProgressData", physicalProgressData);
//       console.log("Bill API Response:", billData);
//       console.log("Bill Count:", billData?.message?.length || billData.length);
//       if (selectedWorkOrderType === "Existing Work Order") {
//         console.log("Existing Bills", filteredBills);

//         setProposalCount(0);

//         setTechnicalCount(filteredPhysicalProgress.length || 0);

//         setWorkorderCount(filteredWorkorder.length || 0);

//         setBillCount(filteredBills.length || 0);

//       } else {

//         setProposalCount(filteredProposals.length || 0);
//         setTechnicalCount(filteredTechnical.length || 0);
//         setWorkorderCount(filteredWorkorder.length || 0);
//         setBillCount(filteredBills.length || 0);
//         setUserRole(proposaldata?.Tabletype || "");
//       }
//     } catch (error) {
//       console.error("Error fetching chart data:", error);
//     } finally {
//       setChartLoading(false);
//     }
//   };

//   const GetAmountOfTaxes = useCallback(async (type) => {
//     try {
//       const data = await GetTaxAmounts(type);
//       SetData(data || {});
//     } catch (error) {
//       console.error("Error fetching tax amounts:", error);
//       SetData({});
//     }
//   }, [GetTaxAmounts]);

//   // ── Filtered data: recompute when typeofData, newData, RoleID, or debouncedSearch changes ──
//   useEffect(() => {
//     if (!newData || newData.length === 0) {
//       setFilteredData([]);
//       setBaseData([]);
//       return;
//     }

//     let filtered = [...newData];

//     // HeadCode filter
//     if ([14, 15, 16, 17, 18, 19, 20, 22, 27, 28, 29, 31].includes(RoleID)) {
//       if (typeofData === "District") {
//         filtered = filtered.filter(item =>
//           item.HeadCode === "3054-2419(Roads and bridge repair maintenance program)"
//         );
//       } else if (typeofData === "State") {
//         filtered = filtered.filter(item =>
//           item.HeadCode === "2515-1238(MLA Representative)"
//         );
//       }
//     }

//     setBaseData(filtered);

//     // Search filter
//     if (debouncedSearch && debouncedSearch.trim()) {
//       const search = normalizeText(debouncedSearch);
//       filtered = filtered.filter((item) => {
//         const combined = normalizeText(`${item.TechnicalSanctionNo} (${item.Work_name})`);
//         return combined.includes(search);
//       });
//     }

//     setFilteredData(filtered);

//     // Tax amounts fetch (only when typeofData changes, not on every search)
//   }, [typeofData, newData, RoleID]); // eslint-disable-line

//   // ── Search filter only (debounced, uses baseData) ─────────────────────────
//   useEffect(() => {
//     if (!debouncedSearch.trim()) {
//       setFilteredData(baseData);
//       return;
//     }
//     const search = normalizeText(debouncedSearch);
//     setFilteredData(
//       baseData.filter((item) => {
//         const combined = normalizeText(`${item.TechnicalSanctionNo || ""} (${item.Work_name || ""})`);
//         return combined.includes(search);
//       })
//     );
//   }, [debouncedSearch, baseData]);

//   // ── Tax amount fetch when typeofData changes ──────────────────────────────
//   useEffect(() => {
//     if (!RoleID) return;
//     const stateRoles = [40, 41, 24, 25];
//     const restrictedRoles = [14, 15, 16, 17, 18, 19, 20, 22, 27, 28, 29, 31];

//     if (restrictedRoles.includes(RoleID)) {
//       GetAmountOfTaxes(typeofData);
//     } else if (stateRoles.includes(RoleID)) {
//       GetAmountOfTaxes("State");
//     } else {
//       GetAmountOfTaxes("");
//     }
//   }, [typeofData, RoleID]); // eslint-disable-line

//   // ── Reset MHUID-related state when typeofData changes (user-driven only) ──
//   useEffect(() => {
//     if (isAutoSettingHeadcode.current) {
//       isAutoSettingHeadcode.current = false;
//       return;
//     }
//     if (!projectId) return;
//     const selectedItem = newData.find((item) => item.Work_name === projectId);
//     if (!selectedItem) return;
//     const headCode = selectedItem.HeadCode || "";
//     const mismatch =
//       (typeofData === "District" && !headCode.startsWith("3054")) ||
//       (typeofData === "State" && !headCode.startsWith("2515"));
//     if (mismatch) {
//       setProjectId("");
//       setSearchTerm("");
//       setMHUID("");
//     }
//   }, [typeofData]); // eslint-disable-line

//   // ── When projectId changes: fetch all project-specific data in parallel ───

//   // ── When selection changes: fetch dashboard/project data ───────────────────
//   useEffect(() => {
//     const fetchProjectData = async () => {
//       setloading(true);

//       try {
//         console.log("selectedWorkOrderType :", selectedWorkOrderType);
//         console.log("projectId :", projectId);
//         console.log("selectedExistingWorkOrder :", selectedExistingWorkOrder);

//         let dashboardPromise;

//         // ================= Dashboard API =================
//         if (!selectedWorkOrderType) {
//           dashboardPromise = GetDateWiseData("", "DashboardOverall", typeofData);
//         }
//         else if (selectedWorkOrderType === "New Work Order") {

//           if (projectId) {
//             dashboardPromise = GetDateWiseData(projectId, "NewProjectfetching", typeofData);
//           } else {
//             dashboardPromise = GetDateWiseData("", "DashboardNewOverall", typeofData);
//           }

//         }
//         else if (selectedWorkOrderType === "Existing Work Order") {

//           if (selectedExistingWorkOrder) {
//             dashboardPromise = GetDateWiseData(
//               selectedExistingWorkOrder,
//               "ExistingProjectFetching", typeofData
//             );
//           } else {
//             dashboardPromise = GetDateWiseData("", "DashboardExistingOverall", typeofData);
//           }

//         }

//         // Fetch dashboard first
//         const dateDataRes = await dashboardPromise;
//         console.log("==================================");
//         console.log("API TYPE :", selectedWorkOrderType);
//         console.log("typeofData :", typeofData);
//         console.log("projectId :", projectId);
//         console.log("Existing :", selectedExistingWorkOrder);
//         console.log("dateDataRes :", dateDataRes);
//         console.log("==================================");

//         setDateData(dateDataRes || []);

//         // ================= Overall Dashboard =================

//         if (!projectId && !selectedExistingWorkOrder) {

//           const workCostRes = await GetTotalTableData(
//             "",
//             "OverallWorkCostData",
//             typeofData,
//             selectedWorkOrderType
//           );

//           setWorkCostData(workCostRes || []);
//           setWorkOrdersData(workCostRes || []);

//           setLimitAllotedData([]);
//           setAmountReleasedData([]);
//           setVendorBills([]);
//           setDeductionData([]);
//           setHeadFetchedData([]);
//           setOverlappingData([]);
//           setCurrentPage(1);

//           return;
//         }

//         const selectedId =
//           selectedWorkOrderType === "Existing Work Order"
//             ? selectedExistingWorkOrder
//             : projectId;

//         console.log("selectedExistingWorkOrder:", selectedExistingWorkOrder);
//         console.log("selectedWorkOrderType:", selectedWorkOrderType);

//         // ================= Project APIs =================
//         const [
//           workCostRes,
//           limitRes,
//           amountReleasedRes,
//           workOrdersRes,
//           vendorBillsRes,
//           deductionRes,
//           headRes,
//           overlapRes,
//         ] = await Promise.all([
//           !projectId && !selectedExistingWorkOrder
//             ? GetTotalTableData(
//               "",
//               "OverallWorkCostData",
//               typeofData,
//               selectedWorkOrderType
//             )
//             : GetTotalTableData(
//               selectedId,
//               selectedWorkOrderType === "Existing Work Order"
//                 ? "ExistingWorkCostData"
//                 : "WorkCostData",
//               typeofData,
//               selectedWorkOrderType
//             ),
//           GetTotalTableData(selectedId, "LimitAllotedData"),
//           GetTotalTableData(selectedId, "AmountReleasedData"),
//           !projectId && !selectedExistingWorkOrder
//             ? GetTotalTableData(
//               "",
//               "OverallWorkCostData",
//               selectedWorkOrderType
//             )
//             : GetTotalTableData(
//               selectedId,
//               "WorkOrdersData",
//               typeofData,
//               selectedWorkOrderType
//             ),
//           GetVendorBills(),
//           GetDateWiseData(selectedId, "deductionFetching", typeofData),
//           GetProjectInfo(selectedId, "getprojectHeadEstimationamount"),
//           GetOverLappingData(proposalUID),
//         ]);

//         setWorkCostData(workCostRes || []);
//         console.log("workCostRes:", workCostRes);
//         console.log("workCostData state will be:", workCostRes || []);
//         setLimitAllotedData(limitRes || []);
//         setAmountReleasedData(amountReleasedRes || []);
//         setWorkOrdersData(workOrdersRes || []);

//         // ================= Vendor Bills =================
//         if (vendorBillsRes) {
//           let filtered = [];

//           if (selectedWorkOrderType === "New Work Order") {
//             filtered = vendorBillsRes.filter(
//               (item) => item.WorkUniqueID === projectId && item.TypeOfAmount === "Total Amount Payable" && item. Status !=="Rejected"
//             );
//           }
//           else if (selectedWorkOrderType === "Existing Work Order") {
//             filtered = vendorBillsRes.filter(
//               (item) => item.WorkOrderID === selectedExistingWorkOrder && item.TypeOfAmount === "Total Amount Payable" && item. Status !=="Rejected"
//             );
//           }

//           setVendorBills(filtered);
//         }

//         setDeductionData(deductionRes || []);
//         setHeadFetchedData(headRes || []);
//         setOverlappingData(overlapRes || []);
//         setCurrentPage(1);

//       } catch (err) {
//         console.error("Error fetching project data:", err);
//       } finally {
//         setloading(false);
//       }
//     };

//     fetchProjectData();

//   }, [
//     projectId,
//     selectedWorkOrderType,
//     selectedExistingWorkOrder,
//     typeofData
//   ]);

//   // ── Charts state ──────────────────────────────────────────────────────────
//   const [state, setState] = React.useState({
//     series: [
//       { name: "High - 2013", data: [28, 29, 33, 36, 32, 32, 33] },
//       { name: "Low - 2013", data: [12, 11, 14, 18, 17, 13, 13] },
//     ],
//     options: {
//       chart: { height: 350, type: 'line', dropShadow: { enabled: true, color: '#000', top: 18, left: 7, blur: 10, opacity: 0.5 }, zoom: { enabled: false }, toolbar: { show: false } },
//       colors: ['#442cfe', '#50bdf5'],
//       dataLabels: { enabled: true },
//       stroke: { curve: 'smooth' },
//       grid: { borderColor: '#e7e7e7', row: { colors: ['#f3f3f3', '#f9f9f9'], opacity: 0.5 } },
//       markers: { size: 5, colors: ['#77B6EA', '#545454'], strokeWidth: 2 },
//       tooltip: { enabled: true, theme: 'dark' },
//       animations: { enabled: true, easing: 'easeinout', speed: 800, animateGradually: { enabled: true, delay: 150 } },
//       xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'] },
//       yaxis: { min: 5, max: 40, labels: { show: false } },
//       legend: { show: false },
//       responsive: [{ breakpoint: 600, options: { chart: { height: 300 }, legend: { position: 'bottom' } } }],
//     },
//   });

//   const [state1, setState1] = React.useState({
//     series: [
//       { name: 'PRODUCT A', data: [44, 55, 41, 67, 22, 43] },
//       { name: 'PRODUCT B', data: [13, 23, 20, 8, 13, 27] },
//       { name: 'PRODUCT C', data: [11, 17, 15, 15, 21, 14] },
//       { name: 'PRODUCT D', data: [21, 7, 25, 13, 22, 8] },
//     ],
//     options: {
//       chart: { type: 'bar', height: 350, stacked: true, toolbar: { show: false }, zoom: { enabled: true } },
//       responsive: [{ breakpoint: 480, options: { legend: { position: 'bottom', offsetX: -10, offsetY: 0 } } }],
//       plotOptions: { bar: { horizontal: false, borderRadius: 10, dataLabels: { total: { enabled: true, style: { fontSize: '18px', fontWeight: 900 } } } } },
//       xaxis: { type: 'datetime', categories: ['01/01/2011 GMT', '01/02/2011 GMT', '01/03/2011 GMT', '01/04/2011 GMT', '01/05/2011 GMT', '01/06/2011 GMT'] },
//       yaxis: { labels: { show: false } },
//       legend: { show: false },
//       fill: { opacity: 1 },
//       colors: ['#442cfe', '#5937fd', '#50bdf5', '#cad1e0'],
//     },
//   });

//   const [state2, setState2] = React.useState({
//     series: [44, 55, 15],
//     options: {
//       chart: { type: 'donut', width: 200, height: 200 },
//       labels: [],
//       colors: ['#442cfe', '#50bdf5', '#ee574c'],
//       legend: { show: false },
//       dataLabels: { enabled: false },
//       responsive: [{ breakpoint: 480, options: { chart: { width: 100, height: 100 }, legend: { position: 'bottom', show: false } } }],
//     },
//   });

//   // PIE CHART 1 — memoized series
//   const pieChart1Series = useMemo(() => {
//     if (selectedWorkOrderType === "Existing Work Order") {
//       return [
//         Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount ?? 0),          // Total Bill Amount
//         Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount ?? 0),// Total Deduction
//         Number(dateData?.Project_Cost ?? getData?.Project_Cost ?? 0),                // Total Work Cost
//         Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders ?? 0),          // Total Work Orders
//       ];
//     }

//     // New Work Order
//     return [
//       Number(dateData?.Project_Cost ?? getData?.Project_Cost ?? 0),
//       Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount ?? 0),
//       Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount ?? 0),
//     ];
//   }, [selectedWorkOrderType, getData, dateData]);

//   const state4 = useMemo(() => ({
//     series: pieChart1Series,
//     options: {
//       chart: {
//         width: 380,
//         type: "pie",
//       },
//       labels:
//         selectedWorkOrderType === "Existing Work Order"
//           ? [
//             "Total Bill Amount",
//             "Total Deduction Amount",
//             "Total Work Cost",
//             "Total Work Orders",
//           ]
//           : [
//             "Project Cost",
//             "Total Deduction Amount",
//             "Total Bill Amount",
//           ],
//       legend: {
//         position: "bottom",
//         horizontalAlign: "center",
//         fontSize: "18px",
//         markers: {
//           radius: 12,
//         },
//       },
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             chart: { width: 200 },
//             legend: { position: "bottom" },
//           },
//         },
//       ],
//     },
//   }), [pieChart1Series, selectedWorkOrderType]);

//   // PIE CHART 2 — memoized
//   const state5 = useMemo(() => {
//     if (selectedWorkOrderType === "Existing Work Order") {
//       return {
//         series: [
//           Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount ?? 0),
//           Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount ?? 0),
//           Number(dateData?.Project_Cost ?? getData?.Project_Cost ?? 0),
//           Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders ?? 0),
//         ],
//         options: {
//           chart: { width: 380, type: "pie" },
//           labels: [
//             "Total Bill Amount",
//             "Total Deduction Amount",
//             "Total Work Cost",
//             "Total Work Orders",
//           ],
//           legend: {
//             position: "bottom",
//             horizontalAlign: "center",
//             fontSize: "18px",
//             markers: { radius: 12 },
//           },
//           responsive: [
//             {
//               breakpoint: 480,
//               options: {
//                 chart: { width: 200 },
//                 legend: { position: "bottom" },
//               },
//             },
//           ],
//         },
//       };
//     }

//     if (!deductionData || deductionData.length === 0) {
//       return {
//         series: [],
//         options: {
//           chart: { width: 380, type: "pie" },
//           labels: [],
//           legend: {
//             position: "bottom",
//             horizontalAlign: "center",
//             fontSize: "18px",
//             markers: { radius: 12 },
//           },
//         },
//       };
//     }

//     return {
//       series: deductionData.map(item => Number(item.TotalAmount)),
//       options: {
//         chart: { width: 380, type: "pie" },
//         labels: deductionData.map(item => item.TypeOfAmount),
//         legend: {
//           position: "bottom",
//           horizontalAlign: "center",
//           fontSize: "18px",
//           markers: { radius: 12 },
//         },
//         responsive: [
//           {
//             breakpoint: 480,
//             options: {
//               chart: { width: 200 },
//               legend: { position: "bottom" },
//             },
//           },
//         ],
//       },
//     };
//   }, [deductionData, selectedWorkOrderType, getData, dateData]);
//   // ── Bar chart options (memoized) ──────────────────────────────────────────
//   const barChartOptions = useMemo(() => {

//     const isExisting =
//       selectedWorkOrderType === "Existing Work Order";

//     return {
//       title: {
//         text: t("Project Statistics")
//       },

//       toolbar: {
//         show: false
//       },

//       colors: isExisting
//         ? ['#064fcf', '#fd7e14', '#01b574']
//         : ['#064fcf', '#fd7e14', '#01b574', '#a3aed0'],

//       plotOptions: {
//         bar: {
//           columnWidth: "40%",
//           distributed: true,
//           borderRadius: 18,
//           borderRadiusApplication: "end",
//         },
//       },
//       grid: {
//         borderColor: "#E8ECF3",
//         strokeDashArray: 5,
//       },

//       legend: {
//         position: "top",
//         horizontalAlign: "center",
//       },

//       dataLabels: {
//         enabled: false,
//       },

//       stroke: {
//         show: false,
//       },

//       xaxis: {
//         categories: isExisting
//           ? [
//             t("Work Order"),
//             t("Physical Progress"),
//             t("Bill"),
//           ]
//           : [
//             t("Proposal"),
//             t("Technical"),
//             t("Work Order"),
//             t("Bills"),
//           ],
//       },

//       yaxis: {
//         title: {
//           text: t("Count"),
//         },
//       },
//     };

//   }, [selectedWorkOrderType, t]);

//   const barChartSeries = useMemo(() => {

//     const isExisting =
//       selectedWorkOrderType === "Existing Work Order";

//     return [{
//       name: t("Count"),
//       data: isExisting
//         ? [
//           workorderCount,
//           technicalCount,
//           billCount,
//         ]
//         : [
//           proposalCount,
//           technicalCount,
//           workorderCount,
//           billCount,
//         ],
//     }];

//   }, [
//     proposalCount,
//     technicalCount,
//     workorderCount,
//     billCount,
//     selectedWorkOrderType,
//     t,
//   ]);

//   // ── Export helpers ────────────────────────────────────────────────────────
//   const exportTableByClassToExcel = (classname, filename = "Export.xlsx") => {
//     const table = document.querySelector(`.${classname}`);
//     if (!table) { alert("Table not found!"); return; }
//     const worksheet = XLSX.utils.table_to_sheet(table);
//     const numCols = table.rows[0].cells.length;
//     worksheet['!cols'] = Array(numCols).fill({ wch: 20 });
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
//     XLSX.writeFile(workbook, filename);
//   };

//   const downloadPageAsPDF = async (tableClass, chartClass, filename, title) => {
//     setloading(true);
//     try {
//       const pdf = new jsPDF('p', 'mm', 'a4');
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();
//       let currentY = 15;
//       if (title) {
//         pdf.setFontSize(18); pdf.setFont(undefined, 'bold');
//         pdf.text(title, pageWidth / 2, currentY, { align: 'center' });
//         currentY += 10;
//       }
//       const originalShowGraph = showGraph;
//       let chartAdded = false;
//       if (originalShowGraph !== "Chart") { setShowGraph("Chart"); await new Promise(r => setTimeout(r, 500)); }
//       const chartElement = document.querySelector(`.${chartClass}`);
//       if (chartElement && isElementVisible(chartElement)) {
//         pdf.setFontSize(14); pdf.text('Chart View', pageWidth / 2, currentY, { align: 'center' }); currentY += 5;
//         const chartCanvas = await html2canvas(chartElement, { scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff' });
//         const chartImgData = chartCanvas.toDataURL('image/png');
//         const chartWidth = pageWidth - 20;
//         const chartHeight = (chartCanvas.height * chartWidth) / chartCanvas.width;
//         if (chartHeight > pageHeight - currentY - 10) {
//           pdf.addPage('l');
//           const lW = pdf.internal.pageSize.getWidth(); const lH = pdf.internal.pageSize.getHeight();
//           currentY = 15; pdf.setFontSize(14); pdf.text('Chart View', lW / 2, currentY, { align: 'center' }); currentY += 5;
//           const aW = lW - 20; const aH = (chartCanvas.height * aW) / chartCanvas.width;
//           pdf.addImage(chartImgData, 'PNG', 10, currentY, aW, Math.min(aH, lH - 25));
//         } else {
//           pdf.addImage(chartImgData, 'PNG', 10, currentY, chartWidth, chartHeight); currentY += chartHeight + 10;
//         }
//         chartAdded = true;
//       }
//       setShowGraph("Table"); await new Promise(r => setTimeout(r, 500));
//       const tableElement = document.querySelector(`.${tableClass}`);
//       let tableAdded = false;
//       if (tableElement && isElementVisible(tableElement)) {
//         if (chartAdded) { pdf.addPage('p'); } else { pdf.setPage(1); }
//         currentY = 15; pdf.setFontSize(14); pdf.text('Table View', pdf.internal.pageSize.getWidth() / 2, currentY, { align: 'center' }); currentY += 5;
//         const tableCanvas = await html2canvas(tableElement, { scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff' });
//         const tableImgData = tableCanvas.toDataURL('image/png');
//         const tableWidth = pdf.internal.pageSize.getWidth() - 20;
//         const tableHeight = (tableCanvas.height * tableWidth) / tableCanvas.width;
//         pdf.addImage(tableImgData, 'PNG', 10, currentY, tableWidth, tableHeight);
//         tableAdded = true;
//       }
//       setShowGraph(originalShowGraph);
//       if (!chartAdded && !tableAdded) { alert('No content found to export!'); return; }
//       const totalPgs = pdf.internal.getNumberOfPages();
//       for (let i = 1; i <= totalPgs; i++) {
//         pdf.setPage(i);
//         const cpw = pdf.internal.pageSize.getWidth(); const cph = pdf.internal.pageSize.getHeight();
//         pdf.setFontSize(8); pdf.setTextColor(128);
//         pdf.text(`Generated on: ${new Date().toLocaleDateString()} | Page ${i} of ${totalPgs}`, cpw / 2, cph - 5, { align: 'center' });
//       }
//       pdf.save(filename); alert('PDF downloaded successfully!');
//     } catch (error) {
//       console.error('Error generating PDF:', error); alert('Failed to download PDF.');
//     } finally {
//       setloading(false);
//     }
//   };

//   const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//     setExportingPDF(true);
//     await new Promise(res => setTimeout(res, 300));
//     const table = document.querySelector(`.${tableClass}`);
//     if (!table) { setExportingPDF(false); return; }
//     const pdf = new jsPDF("p", "mm", "a4");
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();
//     pdf.setFontSize(16); pdf.setFont("helvetica", "bold");
//     pdf.text(title, pageWidth / 2, 15, { align: "center" });
//     const canvas = await html2canvas(table, { scale: 2, useCORS: true, backgroundColor: "#fff" });
//     const imgData = canvas.toDataURL("image/png");
//     const imgWidth = pageWidth - 20;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     let heightLeft = imgHeight; let position = 25;
//     pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;
//     while (heightLeft > 0) {
//       position = heightLeft - imgHeight + 25; pdf.addPage();
//       pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }
//     pdf.save(filename); setExportingPDF(false);
//   };

//   const showHeadDetails =
//     selectedWorkOrderType !== "Existing Work Order" &&
//     headFetchedData;

//   const isLargeAmount =
//     String(Number(dateData?.LiabalityAmount ?? 0)).length > 10 ||
//     String(Number(dateData?.TotalDeductionAmount ?? 0)).length > 10;

//  // ── Render ────────────────────────────────────────────────────────────────
//   const pagetotalpaidamt1 = currentTableData?.reduce((sum, item) => {
//     const amount = Number(item.ApprovedWorkAmount ||
//                                       item.Proposal_amount );
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);
//     const totalpaidamt1 = tableData?.reduce((sum, item) => {
//     const amount = Number(item.ApprovedWorkAmount ||
//                                       item.Proposal_amount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);

//     const pagetotalpaidamt2 = currentTableData?.reduce((sum, item) => {
//     const amount = Number(item.TotalBillAmount );
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);
//     const totalpaidamt2 = tableData?.reduce((sum, item) => {
//     const amount = Number(item.TotalBillAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);  return (
//     <>
//       <div style={{ backgroundColor: '#f4f7fc', padding: '20px', overflowY: 'scroll', height: '90vh' }}>

//         {showspecific === 0 && (
//           <>
//             <div><h1 className="dashboard-title">{t("Project Dashboard")}</h1></div>

//             {(newData?.length > 0 || existingData?.length > 0) ? (
//               <div className="dashboardFilterContainer">
//                 <div className="dashboardFilterRow"
//                 >
//                   {[14, 15, 16, 17, 18, 19, 20, 22, 27, 28, 29, 31].includes(RoleID) && (
//                     <div className="dashboardFilterItem">
//                       <label style={{ fontWeight: "600" }}>{t("Select Head Code")}</label>
//                       <select
//                         value={typeofData}
//                         className="form-control"
//                         onChange={(e) => {
//                           settypeofData(e.target.value);
//                           setMHUID(""); setProjectId(""); setSearchTerm("");
//                         }}
//                       >
//                         <option value="Select Head Code" disabled>Select Head Code</option>
//                         <option value="District">3054-2419(Roads and bridge repair maintenance program)</option>
//                         <option value="State">2515-1238(MLA Representative)</option>
//                       </select>
//                     </div>
//                   )}

//                   <div className="dashboardFilterItem">
//                     <label style={{ fontWeight: "700" }}>
//                       Work Order Type
//                     </label>

//                     <select
//                       className="form-control"
//                       value={selectedWorkOrderType}
//                       onChange={(e) => {
//                         setSelectedWorkOrderType(e.target.value);

//                         // Clear previous selection
//                         setProjectId("");
//                         setSearchTerm("");
//                         setMHUID("");
//                       }}
//                       style={{ width: "180px" }}
//                     >
//                       <option value="">Select Work Order Type</option>
//                       <option value="New Work Order">New Work Order</option>
//                       <option value="Existing Work Order">Existing Work Order</option>
//                     </select>
//                   </div>

//                   {selectedWorkOrderType === "New Work Order" && (
//                     <div className="dashboardFilterItem">
//                       <label style={{ fontWeight: "700", }}>{t("Select MHUID")}</label>
//                       <select
//                         name="projectId"
//                         className="form-control"
//                         value={projectId}
//                         onChange={(e) => {
//                           const selectedValue = e.target.value;
//                           const selectedItem = baseData.find((item) => item.Work_name === selectedValue);
//                           if (selectedItem) {
//                             console.log("Selected Item:", selectedItem);   
//                             isAutoSettingHeadcode.current = true;
//                             if (selectedItem.HeadCode?.startsWith("3054")) settypeofData("District");
//                             else if (selectedItem.HeadCode?.startsWith("2515")) settypeofData("State");
//                             setProjectId(selectedItem.Work_name);
//                             console.log("Setting projectId:", selectedItem.Work_name);
//                             setProposalUID(selectedItem.ProposalID);
//                             setMHUID(selectedItem.TechnicalSanctionNo);
//                             setSearchTerm(`${selectedItem.TechnicalSanctionNo} (${selectedItem.Work_name})`);
//                             if (selectedItem.Proposal_year) setSelectedYear(selectedItem.Proposal_year);
//                           } else {
//                             setProjectId(""); setSearchTerm("");
//                           }
//                           setShowList(false);
//                         }}

//                       >
//                         <option value="" disabled>{t("Please Select MHUID")}</option>
//                         {baseData.map((item, index) => (
//                           <option key={index} value={item.Work_name}>
//                             {item.TechnicalSanctionNo} ({item.Work_name})
//                           </option>
//                         ))}
//                       </select>
//                     </div>

//                   )}


//                   {selectedWorkOrderType === "Existing Work Order" && (
//                     <div className="dashboardFilterItem">
//                       <label style={{ fontWeight: "700", }}>
//                         Work Name
//                       </label>

//                       <select
//                         className="form-control"
//                         value={selectedExistingWorkOrder}
//                         onChange={(e) => {
//                           const value = e.target.value;

//                           setSelectedExistingWorkOrder(value);

//                           const selectedItem = existingData.find(
//                             item => item.WorkOrderID === value
//                           );

//                           if (selectedItem) {
//                             setProjectId(selectedItem.WorkOrderID);
//                             console.log("ProjectId sent to API:", selectedItem.WorkOrderID);
//                             setSearchTerm(selectedItem.WorkName);
//                             setMHUID("");
//                           } else {
//                             setProjectId("");
//                             setSearchTerm("");
//                           }
//                         }}

//                       >
//                         <option value="">Select Work Order</option>

//                         {existingData.map((item, index) => (
//                           <option key={index} value={item.WorkOrderID}>
//                             {item.WorkName}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   )}


//                   <div className="dashboardFilterItem" style={{ position: "relative" }}>

//                     <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                       <label style={{ fontWeight: "700" }}>{t("Search")}</label>

//                       <input
//                         type="text"
//                         className="form-control"
//                         value={searchTerm}
//                         onChange={(e) => {
//                           setSearchTerm(e.target.value);
//                           setShowList(true);
//                         }}
//                         onFocus={() => setShowList(true)}
//                         placeholder={
//                           selectedWorkOrderType === "Existing Work Order"
//                             ? t("Search Work Order")
//                             : t("Search Here")
//                         }
//                       />
//                     </div>

//                     {showList &&
//                       searchTerm &&
//                       (
//                         selectedWorkOrderType === "Existing Work Order"
//                           ? existingData.filter(
//                             (item) =>
//                               item.WorkOrderID
//                                 ?.toLowerCase()
//                                 .includes(searchTerm.toLowerCase()) ||
//                               item.WorkName
//                                 ?.toLowerCase()
//                                 .includes(searchTerm.toLowerCase())
//                           )
//                           : filteredData
//                       ).length > 0 && (

//                         <div
//                           style={{
//                             position: "absolute",
//                             top: "45px",
//                             left: "172px", // aligns with input after the 160px label
//                             width: "250px", // same as input width
//                             maxHeight: "250px",
//                             overflowY: "auto",
//                             background: "white",
//                             border: "1px solid #ccc",
//                             borderRadius: "4px",
//                             zIndex: 1000,
//                           }}
//                         >

//                           {(selectedWorkOrderType === "Existing Work Order"
//                             ? existingData.filter(
//                               (item) =>
//                                 item.WorkOrderID
//                                   ?.toLowerCase()
//                                   .includes(searchTerm.toLowerCase()) ||
//                                 item.WorkName
//                                   ?.toLowerCase()
//                                   .includes(searchTerm.toLowerCase())
//                             )
//                             : filteredData
//                           ).map((item, index) => (

//                             <div
//                               key={index}
//                               style={{
//                                 padding: "8px",
//                                 cursor: "pointer",
//                               }}
//                               onMouseEnter={(e) =>
//                                 (e.currentTarget.style.background = "#f1f1f1")
//                               }
//                               onMouseLeave={(e) =>
//                                 (e.currentTarget.style.background = "white")
//                               }
//                               onClick={() => {

//                                 if (selectedWorkOrderType === "Existing Work Order") {

//                                   setSelectedExistingWorkOrder(item.WorkOrderID);
//                                   setProjectId(item.ProjectID);
//                                   setSearchTerm(
//                                     `${item.WorkOrderID} (${item.WorkName})`
//                                   );
//                                   setMHUID("");
//                                   setShowList(false);

//                                 } else {

//                                   isAutoSettingHeadcode.current = true;

//                                   if (item.HeadCode?.startsWith("3054"))
//                                     settypeofData("District");
//                                   else if (item.HeadCode?.startsWith("2515"))
//                                     settypeofData("State");

//                                   setProjectId(item.Work_name);
//                                   setProposalUID(item.ProposalID);
//                                   setSearchTerm(
//                                     `${item.TechnicalSanctionNo} (${item.Work_name})`
//                                   );
//                                   setMHUID(item.TechnicalSanctionNo);
//                                   setShowList(false);
//                                   if (item.Proposal_year) setSelectedYear(item.Proposal_year);

//                                 }

//                               }}
//                             >

//                               {selectedWorkOrderType === "Existing Work Order"
//                                 ? `${item.WorkOrderID} (${item.WorkName})`
//                                 : `${item.TechnicalSanctionNo} (${item.Work_name})`}

//                             </div>

//                           ))}

//                         </div>

//                       )}

//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <h4 style={{ textAlign: 'center' }}>{t("No Proposals Found")}</h4>
//             )}

//             {loading ? (
//               <div className="Adminloader"></div>
//             ) : (
//               <>
//                 {(newData?.length > 0 || existingData?.length > 0) ? (

//                   <>
//                     {/* ── Summary cards ── */}
//                     <div className={`dashboardSummary ${isLargeAmount ? "twoCards" : ""}`}>

//                       {/* Total Work Cost */}
//                       <div
//                         onClick={() => {

//                           const amount = Number(dateData?.Project_Cost ?? getData?.Project_Cost);

//                           if (amount === 0) return;

//                           setShowWorkCostTable(!showWorkCostTable);
//                           setCurrentPage(1);
//                           setShowSpecific(1);
//                         }}
//                         className="dashboardCard workCostCard"

//                         style={{
//                           cursor:
//                             Number(dateData?.Project_Cost ?? getData?.Project_Cost) > 0
//                               ? "pointer"
//                               : "not-allowed",
//                           opacity:
//                             Number(dateData?.Project_Cost ?? getData?.Project_Cost) > 0
//                               ? 1
//                               : 0.6,
//                         }}
//                       >
//                         <div className="cardContent">
//                           <div className="cardIcon">
//                             <img src={TotalProjectCost11} alt="" />
//                           </div>

//                           <div className="cardDetails">
//                             <h6>{t("Total Work Cost")}</h6>
//                             <h5>
//                               {console.log("Current KPI Data", dateData)
//                               }
//                               ₹{" "}
//                               {formatINR(dateData?.Project_Cost ?? getData?.Project_Cost
//                               )}
//                             </h5>
//                           </div>

//                           <div className="arrow-icon">
//                             <img
//                               src="/Arrow-Total-Original-Limit-Allocated.png"
//                               alt=""
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       {/* Total Work Orders */}
//                       <div
//                         onClick={() => {
//                           const amount = Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders);

//                           if (amount === 0) return;
//                           setShowWorkOrdersTable(!showWorkOrdersTable);
//                           setCurrentPage(1);
//                           setShowSpecific(4);
//                         }}
//                         className="dashboardCard workOrderCard"
//                         style={{
//                           cursor:
//                             Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders) > 0
//                               ? "pointer"
//                               : "not-allowed",
//                           opacity:
//                             Number(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders) > 0
//                               ? 1
//                               : 0.6,
//                         }}
//                       >
//                         <div className="cardContent">
//                           <div className="cardIcon">
//                             <img src={TotalWorkOrders} alt="" />
//                           </div>

//                           <div className="cardDetails">
//                             <h6>{t("Total Work Orders")}</h6>
//                             <h5>
//                               {formatINR(dateData?.TotalWorkOrders ?? getData?.TotalWorkOrders)}
//                             </h5>
//                           </div>

//                           <div className="arrow-icon">
//                             <img
//                               src="/Arrow-Total-Original-Limit-Allocated.png"
//                               alt=""
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       {/* Total Bill Amount */}
//                       <div
//                         onClick={async () => {
//                           const amount = Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount);

//                           if (amount === 0) return;

//                             console.log("Card Click:", {
//                               projectId,
//                               selectedExistingWorkOrder,
//                               selectedWorkOrderType,
//                             });

//                             const selectedId =
//                               selectedWorkOrderType === "Existing Work Order"
//                                 ? selectedExistingWorkOrder
//                                 : projectId;

//                           const res = await GetDateWiseData(
//                              selectedId,
//                             "BillSummary",
//                             typeofData,
//                             selectedWorkOrderType,

//                           );

//                           setBillSummaryData(res);
//                           setCurrentPage(1);
//                           setShowSpecific(5);
//                         }}
//                         className="dashboardCard billCard"
//                         style={{
//                           cursor:
//                             Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount) > 0
//                               ? "pointer"
//                               : "not-allowed",
//                           opacity:
//                             Number(dateData?.LiabalityAmount ?? getData?.LiabalityAmount) > 0
//                               ? 1
//                               : 0.6,
//                         }}
//                       >
//                         <div className="cardContent">
//                           <div className="cardIcon">
//                             <img src={TotalBillAmount64} alt="" />
//                           </div>

//                           <div className="cardDetails">
//                             <h6>{t("Total Bill Amount")}</h6>
//                             <h5>
//                               ₹{" "}
//                               {(Number(
//                                 dateData?.LiabalityAmount ?? getData?.LiabalityAmount
//                               ) || 0).toLocaleString("en-IN")}
//                             </h5>
//                           </div>
//                           <div className="arrow-icon">
//                             <img
//                               src="/Arrow-Total-Original-Limit-Allocated.png"
//                               alt=""
//                             />
//                           </div>
//                         </div>
//                       </div>

//                       {/* Total Deduction Amount */}
//                       <div onClick={async () => {
//                         console.log("Total Deduction Amount Clicked");
//                         const amount = Number(
//                           dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount
//                         );

//                         if (amount === 0) return;

//                           const selectedId =
//                             selectedWorkOrderType === "Existing Work Order"
//                               ? selectedExistingWorkOrder
//                               : projectId;

//                         const res = await GetDateWiseData(
//                            selectedId,
//                           "DeductionSummary",
//                           typeofData,
//                           selectedWorkOrderType,
//                         );

//                         console.log("DeductionSummary Response:", res);

//                         setBillSummaryData(res);
//                         setCurrentPage(1);
//                         setShowSpecific(7);
//                       }}
//                         className="dashboardCard deductionCard" style={{
//                           cursor:
//                             Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount) > 0
//                               ? "pointer"
//                               : "not-allowed",
//                           opacity:
//                             Number(dateData?.TotalDeductionAmount ?? getData?.TotalDeductionAmount) > 0
//                               ? 1
//                               : 0.6,
//                         }}>
//                         <div className="cardContent">
//                           <div className="cardIcon">
//                             <img src={TotalDeductionAmount64} alt="" />
//                           </div>

//                           <div className="cardDetails">
//                             <h6>{t("Total Deduction Amount")}</h6>
//                             <h5>
//                               ₹{" "}
//                               {(Number(
//                                 dateData?.TotalDeductionAmount ??
//                                 getData?.TotalDeductionAmount
//                               ) || 0).toLocaleString("en-IN")}
//                             </h5>
//                           </div>
//                           <div className="arrow-icon">
//                           <img
//                             src="/Arrow-Total-Original-Limit-Allocated.png"
//                             alt=""
//                           />
//                         </div>
//                         </div>     
//                       </div>

//                     </div>

//                     <div className="dashboardChartSection" style={{
//                       alignItems: "stretch"
//                     }}>

//                       {/* Left Side */}
//                       <div className="dashboardLeft" style={{
//                         display: "flex",
//                         flexDirection: "column"
//                       }}>

//                         {/* Bar Chart */}
//                         <div className="chartCard">

//                           <div className="chartHeader">
//                             <h3>{t("Categories")}</h3>

//                             <div className="yearFilter">
//                               <label>{t("Select Year")} :</label>

//                               <select
//                                 value={selectedYear}
//                                 onChange={(e) => setSelectedYear(e.target.value)}
//                               >
//                                 <option value="All">{t("All Years")}</option>
//                                 <option value="2026-2027">2026-2027</option>
//                                 <option value="2025-2026">2025-2026</option>
//                                 <option value="2024-2025">2024-2025</option>
//                                 <option value="2023-2024">2023-2024</option>
//                                 <option value="2022-2023">2022-2023</option>
//                                 <option value="2021-2022">2021-2022</option>
//                                 <option value="2020-2021">2020-2021</option>
//                                 <option value="2019-2020">2019-2020</option>
//                                 <option value="2018-2019">2018-2019</option>
//                               </select>
//                             </div>

//                           </div>

//                           {chartLoading ? (
//                             <div className="chartLoader">
//                               <div className="spinner" />
//                             </div>
//                           ) : (
//                             <ReactApexChart
//                               type="bar"
//                               height={400}
//                               series={barChartSeries}
//                               options={barChartOptions}
//                             />
//                           )}
//                         </div>

//                       </div>

//                       {/* Right Side */}

//                       <div className="dashboardRight" style={{
//                         display: "flex"
//                       }}>

//                         <div className="pieChartCard">

//                           <h3>{t("Taxes And Amounts")}</h3><br></br>

//                           {!deductionData?.length ? (

//                             <ReactApexChart
//                               options={state4.options}
//                               series={state4.series}
//                               type="donut"
//                               height={400}
//                             />

//                           ) : (

//                             <ReactApexChart
//                               options={state5.options}
//                               series={state5.series}
//                               type="donut"
//                               height={400}
//                             />

//                           )}

//                         </div>

//                       </div>

//                     </div>

//                     {/* Vendor Bills + Head Details */}
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: "20px",
//                         alignItems: "stretch",
//                         marginTop: "20px",
//                         flexWrap: "nowrap",
//                       }}
//                     >

//                       {/* ================= Vendor Bills (65%) ================= */}
//                       <div
//                         style={{
//                           flex: showHeadDetails ? "0 0 100%" : "1",
//                           background: "#fff",
//                           borderRadius: "18px",
//                           padding: "20px",
//                           boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
//                           border: "1px solid #edf1f7",
//                         }}
//                       >
//                         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
//                           <h3 style={{ margin: 0 }}>{t("Vendor Bills")}</h3>
//                         </div>

//                         <div className="tableDesign" style={{ background: "#2C78DB" }}>
//                           <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                             <thead>
//                               <tr style={{ color: "white", height: "3rem", fontSize: "18px" }}>
//                                <th style={{ width: "20%" }}>{t("BILL NUMBER/PROJECT ID")}</th>
//                                 <th style={{ width: "15%" }}>{t("NAME")}</th>
//                                 <th style={{ width: "22%" }}>{t("TOTAL AMOUNT PAYABLE")}</th>
//                                 <th style={{ width: "22%" }}>{t("DEDUCTION")}</th>
//                                 <th style={{ width: "10%" }}>{t("STATUS")}</th>
//                                 <th style={{ width: "28%" }}>{t("DATE")}</th>
//                                 <th style={{ width: "9%" }}>{t("PROGRESS")}</th>
//                               </tr>
//                             </thead>

//                             <tbody>
//                               {currentTableData.length < 1 ? (
//                                 <tr>
//                                   <td
//                                     colSpan="7"
//                                     style={{
//                                       textAlign: "center",
//                                       padding: "20px",
//                                       background: "#f9f9f9",
//                                       fontSize: "18px"
//                                     }}
//                                   >
//                                     {t("No Bills Found")}
//                                   </td>
//                                 </tr>
//                               ) : (
//                                 currentTableData.map((bill, index) => {
//                                   const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

//                                   let icon =
//                                     bill.Status === "Sent to Bank"
//                                       ? forth
//                                       : bill.Status === "Successful/Paid"
//                                         ? third
//                                         : bill.Status === "false"
//                                           ? Second
//                                           : first;

//                                   return (
//                                     <tr
//                                       key={index}
//                                       style={{
//                                         background: bgColor,
//                                         fontSize: "18px",
//                                         fontWeight: 500,
//                                       }}
//                                     >
//                                       <td>{bill.UniqueID}</td>

//                                       <td>{bill.Vendor_Company_Name}</td>
//                                       <td>{bill.TotalAmount}</td>
//                                       <td>{bill.DeductionAmount}</td>
//                                       <td>
//                                         <div
//                                           style={{
//                                             display: "flex",
//                                             alignItems: "center",
//                                             gap: "4px",
//                                           }}
//                                         >
//                                           {/* <img
//                                             src={
//                                               bill.Status === "Sent to Bank" ||
//                                                 bill.Status === "Successful/Paid"
//                                                 ? Approved32
//                                                 : Disable32
//                                             }
//                                             width={14}
//                                             alt=""
//                                           />
//                                           {getApprovalStatus(bill)} */}{bill.Status}
//                                         </div>
//                                       </td>

//                                       <td>{bill.UploadedOn?.slice(0, 10)}</td>

//                                       <td style={{ textAlign: "center" }}>
//                                         <img src={icon} alt="" />
//                                       </td>
//                                     </tr>
//                                   );
//                                 })
//                               )}
//                             </tbody>
//                           </table>
//                         </div>

//                         {/* <div
//                           style={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             marginTop: "15px",
//                           }}
//                         >
//                           <button
//                             onClick={() =>
//                               setCurrentPage((p) => Math.max(p - 1, 1))
//                             }
//                             disabled={totalPages === 0 || currentPage === 1}
//                           >
//                             {t("Previous")}
//                           </button>

//                           <span>
//                             {t("Page")} {totalPages === 0 ? 0 : currentPage} {t("of")}{" "}
//                             {totalPages}
//                           </span>

//                           <button
//                             onClick={() =>
//                               setCurrentPage((p) => Math.min(p + 1, totalPages))
//                             }
//                             disabled={currentPage === totalPages}
//                           >
//                             {t("Next")}
//                           </button>
//                         </div> */}
//                       </div>

//                       {/* ================= Head Details (35%) ================= */}

//                       {/* {showHeadDetails && (
//                         <div
//                           style={{
//                             flex: "0 0 35%",
//                             background: "#fff",
//                             borderRadius: "18px",
//                             padding: "20px",
//                             boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
//                             border: "1px solid #edf1f7",
//                             overflowY: "auto",
//                             maxHeight: "430px",
//                           }}
//                         >
//                           <h3 style={{ marginBottom: "15px" }}>
//                             {t("Head Details")}
//                           </h3>

//                           <table className="table table-striped">
//                             <thead className="table-primary">
//                               <tr>
//                                 <th>{t("Sr.No")}</th>
//                                 <th>{t("Head ID")}</th>
//                                 <th>{t("Head Name")}</th>
//                               </tr>
//                             </thead>

//                             <tbody>
//                               {headFetchedData.map((item, index) => (
//                                 <tr key={index}>
//                                   <td>{index + 1}</td>
//                                   <td>{item.HeadID}</td>
//                                   <td>{item.HeadName}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>

//                         </div>

//                       )} */}

//                     </div>


//                     {/* ── Overlapping summary ── */}
//                     {selectedWorkOrderType !== "Existing Work Order" && (
//                       // Your complete District Wise Overlapping TS Summary Report
//                       <div className="col-12 mb-3 mt-3" style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px" }}>
//                         <h3 className='text-center fw-bold'>{t("District Wise Overlapping TS Summary Report")}</h3>
//                         <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
//                           <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                 <th style={{ width: "10%" }}>{t("Scheme Name")}</th>
//                                 <th style={{ width: '10%' }}>{t("District Name")}</th>
//                                 <th style={{ width: '15%' }}>{t("Gram Panchayat Name")}</th>
//                                 <th style={{ width: '25%' }}>{t("Work Name")}</th>
//                                 <th style={{ width: '20%' }}>{t("TS Amount")}</th>
//                                 <th style={{ width: '20%' }}>{t("Overlapped MHUID")}</th>
//                                 <th style={{ width: '20%' }}>{t("Remark Of Overlapping")}</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {overlappingData?.length === 0 ? (
//                                 <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>{t("No data available")}</td></tr>
//                               ) : overlappingData?.map((head, index) => (
//                                 <tr key={index} style={{ backgroundColor: "#E5F4FB", fontSize: "18px", fontWeight: "500" }}>
//                                   <td style={{ padding: '8px' }}>{head?.HeadCode}</td>
//                                   <td style={{ padding: '8px' }}>{head?.District}</td>
//                                   <td style={{ padding: '8px' }}>{head?.GramPanchayat}</td>
//                                   <td style={{ padding: '8px' }}>{head?.WorkName}</td>
//                                   <td style={{ padding: '8px' }}>{head?.TechnicalSanctionAmt}</td>
//                                   <td style={{ padding: '8px' }}>{head?.TechnicalSanctionNo}</td>
//                                   <td style={{ padding: '8px' }}>{head?.remark}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     )}



//                   </>
//                 ) : (
//                   <h4 style={{ textAlign: 'center', marginTop: '20px' }}>{t("No data found")}</h4>
//                 )}
//               </>
//             )}
//           </>
//         )}

//         {/* ── Detail views ── */}
//         {tableData && showspecific === 1 && (
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12'>
//                 <div className="col-12"><button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button></div>
//                 <div className="col-11 my-0 mx-auto">
//                   <div className="row">
//                     <div className="col-12 py-2 d-flex justify-content-left align-items-center">
//                       <h5 className="my-auto fw-bold d-flex align-items-center">
//                         <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                         <span>
//                           {selectedWorkOrderType === "Existing Work Order"
//                             ? t("Total Work Cost for Work Name")
//                             : `${t("Total Work Cost for MHUID")} - ${MHUID}`}
//                         </span>
//                       </h5>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12 pb-5">
//                   <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
//                     <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto' }}>
//                       <table className='m-0 py-0 ALlWorkCostData' style={{ width: '100%', borderCollapse: 'collapse', fontSize: "18px" }}>
//                         <thead style={{fontSize: "18px"}}>
//                           <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Sr.No")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Taluka")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("HeadCode")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Work Name")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("MHUID")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Work Amount (₹)")}</th>
//                           </tr>
//                         </thead>

//                         <tbody>

//                           {console.log("workCostData:", workCostData.length)}
//                           {console.log("tableData:", tableData.length)}
//                           {console.log("currentTableData:", currentTableData.length)}

//                           {currentTableData?.length > 0 ? (
//                             <>
//                               {currentTableData.map((item, idx) => (
//                                 <tr
//                                   key={idx}
//                                   style={{
//                                     backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
//                                     fontSize: "18px",
//                                     fontWeight: "400",
//                                   }}
//                                 >
//                                   <td style={{ fontSize: "18px" }}>{(currentPage - 1) * billsPerPage + idx + 1}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.Taluka}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.HeadCode}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.WorkName || item.Work_name}</td>


//                                   {/* <td>
//                                     {selectedWorkOrderType === "Existing Work Order"
//                                       ? "-"
//                                       : item.TechnicalUID || MHUID}
//                                   </td> */}

//                                   <td style={{ fontSize: "18px" }}>
//                                     {selectedWorkOrderType === "Existing Work Order"
//                                       ? "-"
//                                       : ["NULL", "null", "", null, undefined].includes(item.TechnicalUID || MHUID)
//                                         ? "-"
//                                         : item.TechnicalUID || MHUID}
//                                   </td>


//                                   <td style={{ fontSize: "18px" }}>
//                                     ₹{" "}
//                                     {Number(
//                                       item.ApprovedWorkAmount ||
//                                       item.Proposal_amount ||
//                                       0
//                                     ).toLocaleString("en-IN")}
//                                   </td>
//                                 </tr>
//                               ))}

//                                                 {/* Grand Total Row */}
//          <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,textAlign:"right" }}>
//                                 <td colSpan={5}>{t("Page Total")}</td>
//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                     pagetotalpaidamt1
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                               </tr>

//                               <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,textAlign:"right"}}>
//                                 <td colSpan={5}>{t("Gross Total")}</td>
//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                  totalpaidamt1                                  ).toLocaleString("en-IN")}
//                                 </td>
//                               </tr>
//                             </>
//                           ) : (
//                             <tr>
//                               <td colSpan={6} className="fw-bold">
//                                 {t("No data found")}
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         height: "4rem",
//                         alignItems: "center",
//                       }}
//                       className="mt-3"
//                     >
//                       <div>
//                         <p className="text-gray-600" style={{ fontSize: "18px" }}>
//                           {t("Showing")}{" "}
//                           {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
//                           {t("to")}{" "}
//                           {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
//                           {t("of")} {tableData.length} {t("entries")}
//                         </p>
//                       </div>

//                       <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages}
//                         onPageChange={setCurrentPage}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {limitAllotedData.length > 0 && showspecific === 2 && (
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12'>
//                 <div className="col-12"><button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button></div>
//                 <div className="col-11 my-0 mx-auto">
//                   <h5 className="my-auto fw-bold d-flex align-items-center">
//                     <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                     <span>{t("Total Limit Alloted for MHUID")} - {MHUID}</span>
//                   </h5>
//                 </div>
//                 <div className="col-12 pb-5">
//                   <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", overflowX: "hidden" }}>
//                     <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto' }}>
//                       <table className='m-0 py-0 ALlWorkCostData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                         <thead>
//                           <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Sr.No")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Taluka")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("HeadCode")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Work Name")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Physical Progress (%)")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Demand Requested (₹)")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Limit Allocated (₹)")}</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {limitAllotedData?.length > 0 ? (() => {
//                             const totaltscount = limitAllotedData.reduce((s, v) => s + parseFloat(v.DemandAmount || 0), 0);
//                             const totaltsamount = limitAllotedData.reduce((s, v) => s + parseFloat(v.OriginalLimitAllocatedAmount || 0), 0);
//                                     const pagetotaltscount = filteredData.reduce((s, v) => s + parseFloat(v.DemandAmount || 0), 0);
//                             const pagetotaltsamount = filteredData.reduce((s, v) => s + parseFloat(v.OriginalLimitAllocatedAmount || 0), 0);
//                             return (<>
//                               {limitAllotedData.map((item, idx) => (
//                                 <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1", fontSize: "18px", fontWeight: "400" }}>
//                                   <td>{idx + 1}</td><td>{item.Taluka}</td><td>{item.HeadCode}</td><td>{item.ProposalID}</td><td>{item.physicalValue}</td>
//                                   <td>₹ {Number(item.DemandAmount).toLocaleString()}</td>
//                                   <td>₹ {Number(item.OriginalLimitAllocatedAmount).toLocaleString()}</td>
//                                 </tr>
//                               ))}
//                              <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0',textAlign:"right" }}>
//                                 <td colSpan={5}>{t("Page Total")}</td>
//                                 <td>₹ {Number(pagetotaltscount).toLocaleString()}</td>
//                                 <td>₹ {Number(pagetotaltsamount).toLocaleString()}</td>
//                               </tr>
//                               <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' ,textAlign:"right"}}>
//                                 <td colSpan={5}>{t("Gross Total")}</td>
//                                 <td>₹ {Number(totaltscount).toLocaleString()}</td>
//                                 <td>₹ {Number(totaltsamount).toLocaleString()}</td>
//                               </tr>
//                             </>);
//                           })() : <tr><td colSpan={7} className='fw-bold'>{t("No data found")}</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {amountReleasedData.length > 0 && showspecific === 3 && (
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12'>
//                 <div className="col-12"><button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button></div>
//                 <div className="col-11 my-0 mx-auto">
//                   <h5 className="my-auto fw-bold d-flex align-items-center">
//                     <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />
//                     <span>{t("Total Amount Release for MHUID")} - {MHUID}</span>
//                   </h5>
//                 </div>
//                 <div className="col-12 pb-5">
//                   <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", overflowX: "hidden" }}>
//                     <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto' }}>
//                       <table className='m-0 py-0 ALlWorkCostData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                         <thead>
//                           <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Sr.No")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Taluka")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("HeadCode")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Work Name")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Physical Progress (%)")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Limit Allocated (₹)")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px" }}>{t("Bill Generated Amount (₹)")}</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {amountReleasedData?.length > 0 ? (() => {
//                             const totaltscount = amountReleasedData.reduce((s, v) => s + parseFloat(v.DemandAmount || 0), 0);
//                             const totaltsamount = amountReleasedData.reduce((s, v) => s + parseFloat(v.ReleaseAmountTillDate || 0), 0);
//                               const pagetotaltscount = filteredData.reduce((s, v) => s + parseFloat(v.DemandAmount || 0), 0);
//                             const pagetotaltsamount = filteredData.reduce((s, v) => s + parseFloat(v.ReleaseAmountTillDate || 0), 0);
//                            return (<>
//                               {amountReleasedData.map((item, idx) => (
//                                 <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1", fontSize: "18px", fontWeight: "400" }}>
//                                   <td>{idx + 1}</td><td>{item.Taluka}</td><td>{item.HeadCode}</td><td>{item.ProposalID}</td><td>{item.physicalValue}</td>
//                                   <td>₹ {Number(item.DemandAmount).toLocaleString()}</td>
//                                   <td>₹ {Number(item.ReleaseAmountTillDate).toLocaleString()}</td>
//                                 </tr>
//                               ))}
//                                 <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' ,textAlign:"right"}}>
//                                 <td colSpan={5}>{t("Page Total")}</td>
//                                 <td>₹ {Number(pagetotaltscount).toLocaleString()}</td>
//                                 <td>₹ {Number(pagetotaltsamount).toLocaleString()}</td>
//                               </tr>
//                               <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0',textAlign:"right" }}>
//                                 <td colSpan={5}>{t("Gross Total")}</td>
//                                 <td>₹ {Number(totaltscount).toLocaleString()}</td>
//                                 <td>₹ {Number(totaltsamount).toLocaleString()}</td>
//                               </tr>
//                             </>);
//                           })() : <tr><td colSpan={7} className='fw-bold'>{t("No data found")}</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {tableData && showspecific === 4 && (
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12'>
//                 <div className="col-12"><button className='btn btn-danger px-3 rounded-4 mb-3 mt-3' onClick={() => setShowSpecific(0)}>{t("Back")}</button></div>
//                 <div className="col-11 my-0 mx-auto">
//                   <h5 className="my-auto fw-bold d-flex align-items-center">
//                     <img src="/GR-Approval64.png" alt="" style={{ width: "24px", height: "24px" }} className="me-2" />

//                     <span>
//                       {selectedWorkOrderType === "Existing Work Order"
//                         ? t("Total Work Order for Work Name")
//                         : `${t("Total Work Order for MHUID")} - ${MHUID}`}
//                     </span>
//                   </h5>
//                 </div>
//                 <div className="col-12 pb-5">
//                   <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", overflowX: "hidden" }}>
//                     <div className='col-12 tableDesign DistrictTableContianerModel2' style={{ background: '#2C78DB', overflowX: 'auto' }}>
//                       <table className='m-0 py-0 ALlWorkCostData' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                         <thead>
//                           <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Sr.No")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Taluka")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("HeadCode")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Work Name")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("MHUID")}</th>
//                             <th style={{ minWidth: "250px", padding: "8px", fontSize: "18px" }}>{t("Work Order Amount (₹)")}</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {tableData?.length > 0 ? (() => {
//                             const totaltsamount = workOrdersData.reduce((s, v) => s + parseFloat(v.ApprovedWorkAmount || 0), 0);
//                             return (<>
//                               {currentTableData.map((item, idx) => (
//                                 <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1", fontSize: "18px", fontWeight: "400" }}>
//                                   <td style={{ fontSize: "18px" }} >{(currentPage - 1) * billsPerPage + idx + 1}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.Taluka ?? item.talulka ?? "-"}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.HeadCode}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.WorkName}</td>
//                                   <td style={{ fontSize: "18px" }}>
//                                     {["NULL", "null", "", null, undefined].includes(item.TechnicalUID)
//                                       ? "-"
//                                       : item.TechnicalUID}
//                                   </td>
//                                   <td style={{ fontSize: "18px" }}>₹ {Number(item.ApprovedWorkAmount).toLocaleString("en-IN")}</td>
//                                 </tr>
//                               ))}
//                               {/* Gross Total Row */}
//                                     <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,textAlign:"right"}}>
//                                 <td colSpan={5}>{t("Page Total")}</td>
//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                    pagetotalpaidamt1
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                               </tr>
//                               <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0", fontSize: "18px",textAlign:"right" }}>
//                                  <td colSpan={5}>{t("Gross Total")}</td>
//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                 totalpaidamt1
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                               </tr>
//                             </>);
//                           })() : <tr><td colSpan={6} className='fw-bold'>{t("No data found")}</td></tr>}
//                         </tbody>
//                       </table>
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         height: "4rem",
//                         alignItems: "center",
//                       }}
//                       className="mt-3"
//                     >
//                       <div>
//                         <p className="text-gray-600" style={{ fontSize: "18px" }}>
//                           {t("Showing")}{" "}
//                           {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
//                           {t("to")}{" "}
//                           {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
//                           {t("of")} {tableData.length} {t("entries")}
//                         </p>
//                       </div>

//                       <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages}
//                         onPageChange={setCurrentPage}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {currentTableData && showspecific === 5 && (
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12'>

//                 <div className="col-12">
//                   <button
//                     className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
//                     onClick={() => setShowSpecific(0)}
//                   >
//                     {t("Back")}
//                   </button>
//                 </div>

//                 <div className="col-11 my-0 mx-auto">
//                   <div className="row">
//                     <div className="col-12 py-2 d-flex justify-content-left align-items-center">
//                       <h5 className="my-auto fw-bold d-flex align-items-center">
//                         <img
//                           src={TotalBillAmount64}
//                           alt=""
//                           style={{ width: "24px", height: "24px" }}
//                           className="me-2"
//                         />
//                         <span>{t("Total Bill Amount")}</span>
//                       </h5>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div
//                     className='m-auto mb-3'
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px"
//                     }}
//                   >
//                     <div
//                       className='col-12 tableDesign DistrictTableContianerModel2'
//                       style={{ background: '#2C78DB', overflowX: 'auto' }}
//                     >
//                       <table className='m-0 py-0 ALlWorkCostData' style={{ width: "100%" }}>
//                         <thead>
//                           <tr style={{ color: "white", height: "3rem", fontSize: "18px" }}>
//                             <th style={{ fontSize: "18px" }}>{t("Sr.No")}</th>
//                             <th style={{ fontSize: "18px" }}>
//                               {RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
//                                 ? t("District")
//                                 : t("Taluka")}
//                             </th>
//                             <th style={{ fontSize: "18px" }}>{t("Total Bill Amount")}</th>
//                             <th style={{ fontSize: "18px" }}>{t("Action")}</th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {currentTableData.length > 0 ? (
//                             <>
//                               {currentTableData.map((item, idx) => (
//                                 <tr
//                                   key={idx}
//                                   style={{
//                                     backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
//                                     fontSize: "18px",
//                                   }}
//                                 >
//                                   <td style={{ fontSize: "18px" }}>{(currentPage - 1) * billsPerPage + idx + 1}</td>

//                                   <td style={{ fontSize: "18px" }}>
//                                     {RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
//                                       ? item.District
//                                       : item.Taluka}
//                                   </td>

//                                   <td style={{ fontSize: "18px" }}>
//                                     ₹ {Number(item.TotalBillAmount).toLocaleString("en-IN")}
//                                   </td>

//                                   <td style={{ fontSize: "18px" }}>
//                                     <button
//                                       className="btn btn-primary btn-sm"
//                                       onClick={async () => {
//                                         const location =
//                                           RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
//                                             ? item.District
//                                             : item.Taluka;

//                                         const selectedId =
//                                           selectedWorkOrderType === "Existing Work Order"
//                                             ? selectedExistingWorkOrder
//                                             : projectId;
 
//                                         const res = await GetDateWiseData(
//                                           selectedId,          // same as KPI card
//                                           "BillDetails",
//                                           typeofData,
//                                           selectedWorkOrderType,
//                                           location             // we'll use this in backend
//                                         );

//                                         setBillDetailsData(res);
//                                         setPreviousPage(5);
//                                         setCurrentPage(1);
//                                         setShowSpecific(6);
//                                       }}
//                                     >
//                                       View
//                                     </button>
//                                   </td>
//                                 </tr>
//                               ))}

//                            {/* page Total */}
//                               <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,textAlign:"right",fontSize:"18px" }}>
//                                 <td colSpan={2}>{t("Page Total")}</td>
//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                   pagetotalpaidamt2
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                                 <td></td>
//                               </tr>
//                               {/* Grand Total */}
//                               <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,textAlign:"right",fontSize:"18px"  }}>
//                                 <td colSpan={2}>{t("Gross Total")}</td>
//                                 <td>
//                                   ₹{" "}
//                                   {Number(
                                   
// totalpaidamt2                                  ).toLocaleString("en-IN")}
//                                 </td>
//                                 <td></td>
//                               </tr>
//                             </>
//                           ) : (
//                             <tr>
//                               <td colSpan={4}>{t("No data found")}</td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         height: "4rem",
//                         alignItems: "center",
//                       }}
//                       className="mt-3"
//                     >
//                       <div>
//                         <p className="text-gray-600" style={{ fontSize: "18px" }}>
//                           {t("Showing")}{" "}
//                           {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
//                           {t("to")}{" "}
//                           {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
//                           {t("of")} {tableData.length} {t("entries")}
//                         </p>
//                       </div>

//                       <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages}
//                         onPageChange={setCurrentPage}
//                       />
//                     </div>

//                   </div>
//                 </div>

//               </div>
//             </div>
//           </div>
//         )}

//         {currentTableData && showspecific === 6 && (
//           <div
//             className="col-12"
//             style={{
//               backgroundColor: "#EFF3F8",
//               height: "90vh",
//               overflowX: "hidden",
//               overflowY: "scroll",
//             }}
//           >
//             <div className="col-11 m-auto">
//               <div className="col-12">

//                 <div className="col-12">
//                   <button
//                     className="btn btn-danger px-3 rounded-4 mb-3 mt-3"
//                     onClick={() => setShowSpecific(previousPage)}
//                   >
//                     {t("Back")}
//                   </button>
//                 </div>

//                 <div className="col-11 my-0 mx-auto">
//                   <div className="row">
//                     <div className="col-12 py-2 d-flex justify-content-left align-items-center">
//                       <h5 className="my-auto fw-bold d-flex align-items-center">
//                         <img
//                           src={TotalBillAmount64}
//                           alt=""
//                           style={{ width: "24px", height: "24px" }}
//                           className="me-2"
//                         />
//                         <span>{t("Bill Details")}</span>
//                       </h5>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div
//                     className="m-auto mb-3"
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px",
//                     }}
//                   >
//                     <div
//                       className="col-12 tableDesign DistrictTableContianerModel2"
//                       style={{ background: "#2C78DB", overflowX: "auto" }}
//                     >
//                       <table
//                         className="m-0 py-0 ALlWorkCostData"
//                         style={{ width: "100%" }}
//                       >
//                         <thead>
//                           <tr
//                             style={{
//                               color: "white",
//                               height: "3rem",
//                               fontSize: "18px",
//                             }}
//                           >
//                             <th style={{ fontSize: "18px" }}>Sr.No</th>
//                             <th style={{ fontSize: "18px" }}>Demand ID</th>
//                             <th style={{ fontSize: "18px" }}>Bill Number</th>
//                             <th style={{ fontSize: "18px" }}>Work Name</th>
//                             <th style={{ fontSize: "18px" }}>District</th>
//                             <th style={{ fontSize: "18px" }}>Taluka</th>
//                             <th style={{ fontSize: "18px" }}>Vendor Name</th>
//                             <th style={{ fontSize: "18px" }}>Bill Amount</th>
//                             <th style={{ fontSize: "18px" }}>Net Payable</th>
//                             <th style={{ fontSize: "18px" }}>Deduction</th>
//                             <th style={{ fontSize: "18px" }}>Creation Date</th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {currentTableData.length > 0 ? (
//                             <>
//                               {currentTableData.map((item, idx) => (
//                                 <tr
//                                   key={idx}
//                                   style={{
//                                     backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
//                                     fontSize: "18px",
//                                   }}
//                                 >
//                                   <td style={{ fontSize: "18px" }}>{(currentPage - 1) * billsPerPage + idx + 1}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.DemandGenerationID}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.RABillNumber}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.ProjectName}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.District}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.ulb}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.ContractorName}</td>
//                                   <td style={{ fontSize: "18px" }}>₹ {Number(item.BillAmount).toLocaleString("en-IN")}</td>
//                                   <td style={{ fontSize: "18px" }}>₹ {Number(item.NetPayableAmount).toLocaleString("en-IN")}</td>
//                                   <td style={{ fontSize: "18px" }}>₹ {Number(item.DeductionAmount).toLocaleString("en-IN")}</td>
//                                   <td style={{ fontSize: "18px" }}>{item.Date}</td>
//                                 </tr>
//                               ))}

//                                   {/* Grand Total */}
//                               <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,textAlign:"right"}}>
//                                 <td colSpan={7}>{t("Page Total")}</td>

//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                     currentTableData.reduce(
//                                       (sum, item) => sum + Number(item.BillAmount || 0),
//                                       0
//                                     )
//                                   ).toLocaleString("en-IN")}
//                                 </td>

//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                     currentTableData.reduce(
//                                       (sum, item) => sum + Number(item.NetPayableAmount || 0),
//                                       0
//                                     )
//                                   ).toLocaleString("en-IN")}
//                                 </td>

//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                     currentTableData.reduce(
//                                       (sum, item) => sum + Number(item.DeductionAmount || 0),
//                                       0
//                                     )
//                                   ).toLocaleString("en-IN")}
//                                 </td>

//                                 <td></td>
//                               </tr>
//                               <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0",textAlign:"right" }}>
//                                 <td colSpan={7}>{t("Gross Total")}</td>

//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                     billDetailsData.reduce(
//                                       (sum, item) => sum + Number(item.BillAmount || 0),
//                                       0
//                                     )
//                                   ).toLocaleString("en-IN")}
//                                 </td>

//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                     billDetailsData.reduce(
//                                       (sum, item) => sum + Number(item.NetPayableAmount || 0),
//                                       0
//                                     )
//                                   ).toLocaleString("en-IN")}
//                                 </td>

//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                     billDetailsData.reduce(
//                                       (sum, item) => sum + Number(item.DeductionAmount || 0),
//                                       0
//                                     )
//                                   ).toLocaleString("en-IN")}
//                                 </td>

//                                 <td></td>
//                               </tr>
//                             </>
//                           ) : (
//                             <tr>
//                               <td style={{ fontSize: "18px" }} colSpan={11}>
//                                 No data found
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         height: "4rem",
//                         alignItems: "center",
//                       }}
//                       className="mt-3"
//                     >
//                       <div>
//                         <p className="text-gray-600" style={{ fontSize: "18px" }}>
//                           {t("Showing")}{" "}
//                           {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
//                           {t("to")}{" "}
//                           {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
//                           {t("of")} {tableData.length} {t("entries")}
//                         </p>
//                       </div>

//                       <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages}
//                         onPageChange={setCurrentPage}
//                       />
//                     </div>
//                   </div>
//                 </div>

//               </div>
//             </div>
//           </div>
//         )}

//         {currentTableData && showspecific === 7 && (
//           <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//             <div className="col-11 m-auto">
//               <div className='col-12'>

//                 <div className="col-12">
//                   <button
//                     className='btn btn-danger px-3 rounded-4 mb-3 mt-3'
//                     onClick={() => setShowSpecific(0)}
//                   >
//                     {t("Back")}
//                   </button>
//                 </div>

//                 <div className="col-11 my-0 mx-auto">
//                   <div className="row">
//                     <div className="col-12 py-2 d-flex justify-content-left align-items-center">
//                       <h5 className="my-auto fw-bold d-flex align-items-center">
//                         <img
//                           src={TotalBillAmount64}
//                           alt=""
//                           style={{ width: "24px", height: "24px" }}
//                           className="me-2"
//                         />
//                         <span>{t("Total Deduction Amount")}</span>
//                       </h5>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div
//                     className='m-auto mb-3'
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px"
//                     }}
//                   >
//                     <div
//                       className='col-12 tableDesign DistrictTableContianerModel2'
//                       style={{ background: '#2C78DB', overflowX: 'auto' }}
//                     >
//                       <table className='m-0 py-0 ALlWorkCostData' style={{ width: "100%" }}>
//                         <thead>
//                           <tr style={{ color: "white", height: "3rem", fontSize: "18px" }}>
//                             <th>{t("Sr.No")}</th>
//                             <th style={{ fontSize: "18px" }}>
//                               {RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
//                                 ? t("District")
//                                 : t("Taluka")}
//                             </th>
//                             <th style={{ fontSize: "18px" }}>{t("Total Deduction Amount")}</th>
//                             <th style={{ fontSize: "18px" }}>{t("Action")}</th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {currentTableData.length > 0 ? (
//                             <>
//                               {currentTableData.map((item, idx) => (
//                                 <tr
//                                   key={idx}
//                                   style={{
//                                     backgroundColor: idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
//                                     fontSize: "18px",
//                                   }}
//                                 >
//                                   <td style={{ fontSize: "18px" }}>{(currentPage - 1) * billsPerPage + idx + 1}</td>

//                                   <td style={{ fontSize: "18px" }}>
//                                     {RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
//                                       ? item.District
//                                       : item.Taluka}
//                                   </td>

//                                   <td style={{ fontSize: "18px" }}>
//                                     ₹ {Number(item.TotalDeductionAmount).toLocaleString("en-IN")}
//                                   </td>

//                                   <td style={{ fontSize: "18px" }}>
//                                     <button
//                                       className="btn btn-primary btn-sm"
//                                       onClick={async () => {
//                                         const location =
//                                           RoleID === 40 || RoleID === 41 || RoleID === 24 || RoleID === 25 || RoleID === 29
//                                             ? item.District
//                                             : item.Taluka;

//                                         const selectedId =
//                                           selectedWorkOrderType === "Existing Work Order"
//                                             ? selectedExistingWorkOrder
//                                             : projectId;

//                                             console.log("selected id ::",selectedId);
                                            


//                                         const res = await GetDateWiseData(
//                                           selectedId,
//                                           "BillDetails",
//                                           typeofData,
//                                           selectedWorkOrderType,
//                                           location
//                                         );

//                                         setSelectedLocation(location);
//                                         setBillDetailsData(res);
//                                         setPreviousPage(7);
//                                         setCurrentPage(1);
//                                         setShowSpecific(6);
//                                       }}
//                                     >
//                                       View
//                                     </button>
//                                   </td>
//                                 </tr>
//                               ))}

//                               {/* Gross Total */}
//                               <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0", fontSize: "18px" ,textAlign:"right" }}>
// <td colSpan={2}>{t("Page Total")}</td>
//                                 <td>
//                                   ₹{" "}
//                                   {Number(
//                                     currentTableData.reduce(
//                                       (sum, item) => sum + Number(item.TotalDeductionAmount || 0),
//                                       0
//                                     )
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                                 <td></td>
//                               </tr>
//                                 <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,textAlign:"right" }}>
//                                 <td colSpan={2}>{t("Gross Total")}</td>                                <td style={{ fontSize: "18px" }}>
//                                   ₹{" "}
//                                   {Number(
//                                     billSummaryData.reduce(
//                                       (sum, item) => sum + Number(item.TotalDeductionAmount || 0),
//                                       0
//                                     )
//                                   ).toLocaleString("en-IN")}
//                                 </td>
//                                 <td style={{ fontSize: "18px" }}></td>
//                               </tr>
//                             </>
//                           ) : (
//                             <tr>
//                               <td style={{ fontSize: "18px" }} colSpan={4}>{t("No data found")}</td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         height: "4rem",
//                         alignItems: "center",
//                       }}
//                       className="mt-3"
//                     >
//                       <div>
//                         <p className="text-gray-600" style={{ fontSize: "18px" }}>
//                           {t("Showing")}{" "}
//                           {tableData.length > 0 ? (currentPage - 1) * billsPerPage + 1 : 0}{" "}
//                           {t("to")}{" "}
//                           {Math.min(currentPage * billsPerPage, tableData.length)}{" "}
//                           {t("of")} {tableData.length} {t("entries")}
//                         </p>
//                       </div>

//                       <GooglePagination
//                         currentPage={currentPage}
//                         totalPages={totalPages}
//                         onPageChange={setCurrentPage}
//                       />
//                     </div>
//                   </div>
//                 </div>

//               </div>
//             </div>
//           </div>
//         )}



//       </div>
//     </>
//   );
// };

// export default Dashboard;